import { j as c, T as Ft, c as k, s as yn, B as xn, C as wn, a as pt, I as oe, w as mt, b as Ht, L as Te, d as vn, e as ot, f as Ne, g as Z, h as qt, S as _n, H as kn, R as Cn, i as jn, k as Tn } from "./ToggleSwitch-8y4ISM6n.mjs";
import { A as xc, l as wc, F as vc, J as _c, m as kc, n as Cc, o as jc } from "./ToggleSwitch-8y4ISM6n.mjs";
import W, { useRef as I, useState as S, useEffect as C, useCallback as _, useMemo as H, forwardRef as ee, useLayoutEffect as ze, Children as Oe, isValidElement as xe, cloneElement as Nn, createContext as Kt, useContext as Ut, useId as Fe, createElement as Yt, memo as Ln } from "react";
import { createPortal as Gt } from "react-dom";
async function zn(e) {
  if (!e)
    return !1;
  await navigator.clipboard.writeText(e);
}
const Sn = (e, t) => Number(e === "en" ? String(t).replace(/[^0-9.]/g, "") : String(t).replace(/[^0-9,]/g, "").replace(/,/g, ".")), ht = {}, An = (e, t, n, r) => {
  const a = `${e}-${t ? "currency" : "noCurrency"}-${n}-${r}`;
  let i = ht[a];
  return i || (i = new Intl.NumberFormat(e ?? "de", {
    minimumFractionDigits: n,
    maximumFractionDigits: n,
    ...t ? { style: "currency", currency: "EUR" } : {},
    ...r ? {} : { useGrouping: !1 }
  }), ht[a] = i), i;
};
function Je(e, t, n = {}) {
  const r = (n == null ? void 0 : n.precision) === void 0 ? 2 : n == null ? void 0 : n.precision, o = typeof t == "number" ? t || 0 : Sn(e, t), a = (n == null ? void 0 : n.thousandSeparator) ?? !0;
  return An(e, !(n != null && n.format), r, a).format(o).replace(/\u00A0/, " ");
}
function bt(e) {
  if (!e)
    return 0;
  const t = e.replace(/,/g, "."), n = parseFloat(t) || 0;
  return Math.round(n * 100);
}
function Ee(e, t = 2) {
  return e.replace(/[^\d.,]/g, "").replace(/^([.,]{1,1})/, "0$1").replace(/^0{2,}/, "0").replace(/^0([\d]+)([\d,.]*)/, "$1$2").replace(/[.,]([^.,]*)(?=[.,])/g, "$1").replace(new RegExp(`([.,]\\d{${t}}).*$`), "$1");
}
function* In(e) {
  for (let t = 0; t < e; ++t)
    yield t;
}
const Pn = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  gold: "#ffd700",
  goldenrod: "#daa520",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  "indianred ": "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavender: "#e6e6fa",
  lavenderblush: "#fff0f5",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgrey: "#d3d3d3",
  lightgreen: "#90ee90",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370d8",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#d87093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Vt(e) {
  const t = e.toLowerCase();
  return Pn[t];
}
function Ue(e, t, n) {
  return Math.max(e, Math.min(t, n));
}
const Ze = "00000000";
function Qe(e, t) {
  if (e === "transparent")
    return e;
  const n = Vt(e) ?? e, r = parseInt(n.replace("#", ""), 16), o = Math.round(2.55 * t), a = Ue(0, (r >> 16 & 255) + o, 255), i = Ue(0, (r >> 8 & 255) + o, 255), s = Ue(0, (r & 255) + o, 255);
  return `#${[a, i, s].map((d) => (d >= 0 ? d : 0).toString(16).padStart(2, "0")).join("")}`;
}
function gt(e, t) {
  return Qe(e, -1 * t);
}
function yt(e) {
  if (e === "transparent")
    return 0;
  const t = Vt(e) ?? e, n = parseInt(t.slice(1, 3), 16) / 255, r = parseInt(t.slice(3, 5), 16) / 255, o = parseInt(t.slice(5, 7), 16) / 255, a = n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4), i = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4), s = o <= 0.03928 ? o / 12.92 : Math.pow((o + 0.055) / 1.055, 2.4);
  return 0.2126 * a + 0.7152 * i + 0.0722 * s;
}
function xt(e) {
  if (!e)
    return;
  const t = typeof e != "string" ? String(e) : e;
  if (e === Ze)
    return "transparent";
  let n = t.match(/^([a-f\d]{3}|[a-f\d]{6})$/i);
  if (n && n[1])
    return `#${n[1]}`;
  if (n = t.match(/^[a-z]+$/i), n)
    return e;
}
function wt(e, t = () => {
}) {
  return new Promise((n, r) => {
    setTimeout(() => {
      try {
        t(), n(void 0);
      } catch (o) {
        r(o);
      }
    }, e);
  });
}
const Ra = [
  "text",
  "number",
  "email",
  "password",
  "search",
  "tel",
  "date",
  "datetime-local",
  "time",
  "url",
  "color"
];
function Mn(e, t, n) {
  const r = I(null), o = I(null), [a, i] = S(null);
  return C(() => {
    o.current = t ?? null;
  }, [t]), C(() => (r.current = new MutationObserver((s) => {
    for (const l of s)
      (typeof o.current != "function" || o.current(l)) && i(l);
  }), r.current.observe(e.current, n), () => {
    var s;
    (s = r.current) == null || s.disconnect();
  }), []), a;
}
function Fa(e, t) {
  const n = _(
    (a) => a.type === "attributes" && a.attributeName === t,
    [t]
  ), r = Mn(e, n, { attributes: !0 });
  return H(
    () => {
      var a;
      return { oldValue: (r == null ? void 0 : r.oldValue) ?? null, newValue: (a = e.current) == null ? void 0 : a.getAttribute(t) };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, t]
  );
}
function at(e) {
  const t = I(null), n = _(
    (r) => {
      if (t.current = r, !!e) {
        if (typeof e == "function") return e(r);
        e.current = r;
      }
    },
    [e]
  );
  return [t, n];
}
const vt = {
  width: void 0,
  height: void 0
};
function On(e) {
  const { ref: t, box: n = "content-box" } = e, [{ width: r, height: o }, a] = S(vt), i = I({ ...vt }), s = I(void 0);
  return s.current = e.onResize, C(() => {
    if (!t || !t.current || !window || typeof window > "u" || !("ResizeObserver" in window)) return;
    const l = new ResizeObserver(([u]) => {
      if (!t.current) return;
      const d = n === "border-box" ? "borderBoxSize" : n === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
      if (!u) return;
      const m = _t(u, d, "inlineSize"), p = _t(u, d, "blockSize");
      if (i.current.width !== m || i.current.height !== p) {
        const b = { width: m, height: p };
        i.current.width = m, i.current.height = p, s.current ? s.current(b) : a(b);
      }
    });
    return l.observe(t.current, { box: n }), () => {
      l.disconnect();
    };
  }, [n, t]), { width: r, height: o };
}
function _t(e, t, n) {
  var o;
  const r = e[t];
  return Array.isArray(r) && r.length > 0 ? (o = r[0]) == null ? void 0 : o[n] : r && typeof r == "object" && n in r ? r[n] : n === "inlineSize" ? e.contentRect.width : e.contentRect.height;
}
function Ha(e, t = 100) {
  const [n, r] = S(e);
  return C(() => {
    const o = setTimeout(() => r(e), t);
    return () => clearTimeout(o);
  }, [e, t]), n;
}
function kt(e) {
  if (typeof e > "u") return;
  let t;
  if (typeof e != "number" ? t = parseFloat(e) : t = e, !isNaN(t))
    return Math.round(t * 100);
}
const En = ee(
  ({
    label: e,
    locale: t = "de",
    name: n,
    id: r,
    min: o = 0,
    onChange: a,
    onBlur: i,
    onFocus: s,
    defaultValue: l,
    value: u,
    step: d,
    children: m,
    className: p,
    hideSteps: h,
    max: b,
    ...x
  }, y) => {
    const g = H(() => Dn(d), [d]), [w, v] = S(
      Ee(
        Je(t, u ?? l ?? "", { precision: g, format: "%v", thousandSeparator: !1 }),
        g
      )
    ), A = H(() => kt(b), [b]), E = H(() => kt(o), [o]), [T, $] = S(null), [f, N] = at(y), D = _(
      (j) => {
        const O = Ct(j.target.value, t, g), U = bt(O);
        if (typeof A < "u" && U > A || typeof E < "u" && U < E) {
          const ve = j.target.selectionStart ? j.target.selectionStart : 0;
          return $(ve), j.preventDefault();
        }
        $(j.target.selectionStart);
        let te = j.target.value;
        O.startsWith(j.target.value) || (te = O);
        const he = bt(j.target.value);
        j.target.value && !isNaN(he) && U === he && (a == null || a(j)), v(te);
      },
      [t, g, E, A, a]
    ), B = _(
      (j) => {
        const O = Ct(j.target.value, t, g);
        O !== j.target.value && (j.target.value = O), $(null), i == null || i(j);
      },
      [i, g, t]
    ), V = _(
      (j) => {
        $(j.target.selectionStart), s == null || s(j);
      },
      [s]
    ), z = H(
      () => l ? { defaultValue: w } : { value: w },
      [l, w]
    );
    return C(() => {
      if (typeof l < "u") return;
      const j = u ?? l;
      if (typeof u > "u")
        return v("");
      const O = Ee(
        Je(t, j, { precision: g, format: "%v", thousandSeparator: !1 }),
        g
      );
      v(O);
    }, [u, g, l, t]), C(() => {
      const j = (w == null ? void 0 : w.length) ?? 0, O = (T ?? 0) > j ? j : T;
      T === null || !f.current || document.activeElement !== f.current || f.current.setSelectionRange(O, O);
    }, [T, f, w]), /* @__PURE__ */ c.jsx(
      Ft,
      {
        ...x,
        ...z,
        onFocus: V,
        onBlur: B,
        onChange: D,
        step: d,
        ref: N,
        id: r || n,
        name: n,
        label: e,
        pattern: "[0-9]*[.,]?[0-9]*",
        type: "text",
        inputMode: "decimal",
        className: k(p, { [yn.hideSteps]: h }),
        children: m
      }
    );
  }
);
En.displayName = "ClientAmountField";
function Ct(e, t, n = 2) {
  if (typeof e > "u" || e === null)
    return e;
  const r = String(e), o = Ee(r, n), a = Je(t, o, { precision: n, format: "%v", thousandSeparator: !1 }), i = Ee(a, n);
  if (!n)
    return i;
  const s = i.search(/[.,]/);
  if (s < 0)
    return i;
  const l = n - (i.length - 1 - s);
  return i.concat("0".repeat(l));
}
function Dn(e) {
  var n;
  return e === void 0 ? void 0 : ((n = String(e).split(".")[1]) == null ? void 0 : n.length) ?? 0;
}
const jt = typeof window < "u" ? ze : C;
function Tt(e) {
  const t = I();
  return C(() => {
    t.current = e;
  }, [e]), t;
}
function $n(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  return Oe.forEach(e, (o) => {
    var l;
    if (!xe(o) || !o.key) return;
    const a = t.get(o.key);
    if (!a) return;
    const s = { top: (l = a.getBoundingClientRect()) == null ? void 0 : l.top, parentTop: n };
    r.set(o.key, s);
  }), r;
}
function ke(e) {
  return e === null ? "" : e.replace(".$", "");
}
function Nt(e, t) {
  const n = /* @__PURE__ */ new Set(), r = [];
  for (const o of e) {
    const a = o.key;
    n.has(a) || (n.add(a), r.push(o));
  }
  for (const o of t) {
    const a = o.key;
    n.has(a) || (n.add(a), r.push(o));
  }
  return r;
}
const Lt = "inset(0)", Ye = "inset(0 0 100% 0)";
function qa({
  children: e,
  animationLengthInMs: t,
  tagToRenderSpy: n = "div"
}) {
  const r = I(null), o = _(
    (h, b, x) => `transform ${h ?? t}ms ease, clip-path ${b ?? t}ms ease, opacity ${x ?? t}ms ease`,
    [t]
  ), [a, i] = S(/* @__PURE__ */ new Map()), s = Tt(e), l = Tt(a), [u, d] = S([]), m = I(/* @__PURE__ */ new Map());
  jt(() => {
    var g, w;
    const h = ((w = (g = r.current) == null ? void 0 : g.parentElement) == null ? void 0 : w.getBoundingClientRect().top) ?? 0;
    i($n(e, m.current, h));
    const b = s.current;
    if (!b) return;
    const x = new Set(
      Oe.map(e, (v) => xe(v) ? ke(v.key) : null)
    ), y = Oe.toArray(b).filter(
      (v) => xe(v) && !x.has(ke(v.key))
    );
    y.length && d((v) => Nt(v, y));
  }, [e, s, r]);
  const p = H(
    () => Nt(Oe.toArray(e), u).filter((h) => xe(h) ? h.key ? !0 : (console.warn("AnimateList got a child with no key, skipping"), !1) : (console.warn("AnimateList got an invalid child"), !1)),
    [e, u]
  );
  return jt(() => {
    var g;
    let h = 0;
    const b = [], x = [], y = new AbortController();
    for (const w of p) {
      if (!xe(w) || !w.key) continue;
      const v = ke(w.key), A = a.get(v), E = (g = l.current) == null ? void 0 : g.get(v), T = m.current.get(v);
      if (!T) continue;
      if (!A) {
        b.push(
          requestAnimationFrame(() => {
            T.style.transition = o(), T.style.transform !== Ye && (T.style.clipPath = Lt, T.style.opacity = "1"), b.push(
              requestAnimationFrame(() => {
                T.style.clipPath = Ye, T.style.opacity = "0";
              })
            );
          })
        ), T.addEventListener(
          "transitionend",
          function(N) {
            N.propertyName === "clip-path" && (d(
              (D) => D.filter(
                (B) => xe(B) && ke(B.key) !== v
              )
            ), m.current.delete(v), y.abort());
          },
          { signal: y.signal }
        );
        continue;
      }
      if (!E || T.style.opacity === "0") {
        const f = Math.round(h * t / 2);
        h++, b.push(
          requestAnimationFrame(() => {
            T.style.clipPath = Ye, T.style.opacity = "0", T.style.transition = o(), x.push(
              setTimeout(() => {
                b.push(
                  requestAnimationFrame(() => {
                    T.style.clipPath = Lt, T.style.opacity = "1";
                  })
                );
              }, f)
            );
          })
        );
        continue;
      }
      const $ = E.top - E.parentTop - (A.top - A.parentTop);
      $ && b.push(
        requestAnimationFrame(() => {
          T.style.transform = `translateY(${$}px)`, T.style.transition = o(0), b.push(
            requestAnimationFrame(() => {
              T.style.transition = o(), T.style.transform = "translateY(0)";
            })
          );
        })
      );
    }
    return () => {
      x.map(clearTimeout), b.map(cancelAnimationFrame), y.signal.aborted || y.abort();
    };
  }, [t, a, o, p]), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(n, { ref: r, style: { maxBlockSize: 0 } }),
    p.map((h) => Nn(h, {
      ref: (b) => {
        m.current.set(ke(h.key), b);
      }
    }))
  ] });
}
const Bn = "_number_j91ks_7", Rn = {
  number: Bn
};
function Fn(e) {
  const t = typeof e == "number" ? e.toString() : e;
  let n = "", r = "";
  const o = [], a = [];
  let i = "", s = !1;
  const l = (u) => typeof u == "string" && /[0-9]/.test(u);
  for (let u = 0; u <= t.length; u++) {
    const d = t[u], m = l(d);
    m && !s && (a.length ? i && o.push(i) : n = i, i = ""), !m && s && (a.push(i), i = ""), !m && !s && (r = i), s = m, i += d;
  }
  return {
    prefix: n,
    suffix: r,
    separators: o,
    integers: a
  };
}
function Hn({ num: e, separator: t }) {
  const n = parseInt(e, 10).toString(), r = Math.max(e.length - n.length, 0);
  return /* @__PURE__ */ c.jsx(
    "span",
    {
      "data-zero-pad": "0".repeat(r),
      "data-separator": t ?? "",
      style: {
        "--number": e
      }
    }
  );
}
function Ka({
  children: e,
  style: t,
  className: n,
  animationDurationInMs: r = 1e3,
  maxNumberScale: o = 2
}) {
  const a = I(null), [i, s] = S(0), l = H(() => Fn(e), [e]), u = H(() => {
    const x = l.integers.length - 1;
    return parseFloat(
      l.integers.slice(0, x).join("") + (l.separators[x - 1] ? "." + l.integers[x] : l.integers[x])
    );
  }, [l]);
  C(() => {
    if (isNaN(u)) return;
    const x = a.current ?? 0, y = u - x;
    if (a.current = u, a.current === null)
      return s(0);
    s(y);
    const g = setTimeout(() => {
      s(0);
    }, r);
    return () => clearTimeout(g);
  }, [r, u]);
  const d = H(
    () => Math.max(Math.max(o - 1, 0) * ((Math.log10(i / 100) + 3) / 4) + 1, 1),
    [i, o]
  );
  if (isNaN(u)) return null;
  const { prefix: m, suffix: p, separators: h, integers: b } = l;
  return /* @__PURE__ */ c.jsxs(
    "div",
    {
      className: k(Rn.number, n),
      "data-prefix": m,
      "data-suffix": p,
      style: {
        ...t,
        "--number-scale": d,
        "--number-animation-duration": `${r}ms`
      },
      children: [
        b.map((x, y) => {
          const g = h[y], w = b.length - 1 - y;
          return /* @__PURE__ */ c.jsx(Hn, { num: x, separator: g }, w);
        }),
        /* @__PURE__ */ c.jsx("span", { className: "sr-only", children: e }, "sr-only")
      ]
    }
  );
}
function K(e) {
  e.preventDefault(), e.stopPropagation();
}
const qn = ee(function({
  onKeyDown: t,
  onKeyUp: n,
  onKeyDownCapture: r,
  onKeyUpCapture: o,
  onClick: a,
  ...i
}, s) {
  const { disabled: l, busy: u } = i, d = l || u, m = d ? K : t, p = d ? K : n, h = d ? K : o, b = d ? K : a;
  return /* @__PURE__ */ c.jsx(
    xn,
    {
      ...i,
      onClick: b,
      onChange: m,
      onKeyUp: p,
      onKeyUpCapture: h,
      ref: s
    }
  );
}), Ua = ee(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: a } = r, i = a ? K : t, s = a ? K : n;
  return /* @__PURE__ */ c.jsx(wn, { ...r, onChange: i, onClick: s, ref: o });
}), Kn = "_tooltipArrow_1nc0z_1", Un = "_bottomTooltipArrow_1nc0z_33", Yn = "_topTooltipArrow_1nc0z_38", Ge = {
  tooltipArrow: Kn,
  bottomTooltipArrow: Un,
  topTooltipArrow: Yn
}, G = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
}, re = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  JUSTIFY: "justify"
};
function ct({ x: e, position: t, className: n }) {
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      className: k(Ge.tooltipArrow, n, {
        [Ge.bottomTooltipArrow]: t === G.BOTTOM,
        [Ge.topTooltipArrow]: t === G.TOP
      }),
      style: { transform: `translateX(${e}px) ${t === G.BOTTOM ? " rotate(180deg)" : ""}` }
    }
  );
}
const Gn = "_picker_yqwd0_1", Vn = "_swatch_yqwd0_7", Wn = "_activeSwatch_yqwd0_19", Xn = "_inactiveSwatch_yqwd0_25", Jn = "_errorSwatch_yqwd0_30", Zn = "_swatchInner_yqwd0_34", Qn = "_activePickerSwatch_yqwd0_41", er = "_dropdown_yqwd0_45", tr = "_popover_yqwd0_49", nr = "_pickerSwatches_yqwd0_55", rr = "_input_yqwd0_68", or = "_label_yqwd0_91", ne = {
  picker: Gn,
  swatch: Vn,
  activeSwatch: Wn,
  inactiveSwatch: Xn,
  errorSwatch: Jn,
  swatchInner: Zn,
  activePickerSwatch: Qn,
  dropdown: er,
  popover: tr,
  pickerSwatches: nr,
  input: rr,
  label: or
}, ar = "_dropdownContent_1n9sv_1", cr = "_dropdownTriggerButton_1n9sv_14", sr = "_scaleTransition_1n9sv_26", ir = "_scaleTransitionOpen_1n9sv_34", lr = "_dropdownMenu_1n9sv_39", ur = "_dropdownMenuSeparator_1n9sv_50", dr = "_dropdownMenuItem_1n9sv_59", me = {
  dropdownContent: ar,
  dropdownTriggerButton: cr,
  scaleTransition: sr,
  scaleTransitionOpen: ir,
  dropdownMenu: lr,
  dropdownMenuSeparator: ur,
  dropdownMenuItem: dr
}, fr = "_popupContainer_y7ppu_1", pr = "_spyElement_y7ppu_15", mr = "_nonFocusableOutline_y7ppu_21", st = {
  popupContainer: fr,
  spyElement: pr,
  nonFocusableOutline: mr
}, hr = {
  a: "link",
  area: "link",
  article: "article",
  aside: "complementary",
  button: "button",
  details: "group",
  dfn: "term",
  dialog: "dialog",
  fieldset: "group",
  figure: "figure",
  footer: "contentinfo",
  form: "form",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  iframe: "document",
  img: "img",
  input: null,
  // for type purposes this value needs to be included
  li: "listitem",
  main: "main",
  menu: "list",
  menuitem: "menuitem",
  meter: "meter",
  nav: "navigation",
  ol: "list",
  option: "option",
  progress: "progressbar",
  section: "region",
  select: "listbox",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  td: "cell",
  textarea: "textbox",
  tfoot: "rowgroup",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
}, br = {
  button: "button",
  checkbox: "checkbox",
  radio: "radio",
  range: "slider",
  text: "textbox",
  password: "textbox",
  email: "textbox",
  search: "searchbox",
  number: "spinbutton",
  tel: "textbox",
  url: "textbox",
  submit: "button",
  reset: "button",
  image: "button",
  file: "textbox"
}, ie = ["a", "button", "input", "textarea", "select", "details", "area", "label"];
function gr(e) {
  return !e || !e.trim() ? /* @__PURE__ */ new Set() : new Set(e.trim().split(/\s+/));
}
function yr(e, t) {
  return [...gr(e).add(t)].join(" ");
}
function xr(e) {
  const t = e.getAttribute("role");
  if (t) return t;
  const n = e.tagName.toLowerCase();
  if (n === "input") {
    const o = e.getAttribute("type");
    return o ? br[o] : "textbox";
  }
  const r = hr[n];
  return r || "button";
}
function Wt(e, t = ie) {
  if (!(!e || !(e instanceof HTMLElement)))
    return e.querySelectorAll(`${t.join(",")},[tabindex]:not([tabindex="-1"])`);
}
function Xt(e, t = ie) {
  if (!e) return !1;
  const n = e.getAttribute("tabindex");
  if (!n && !t.includes(e.tagName.toLowerCase()) || n && parseInt(n) < 0 || e.hasAttribute("disabled")) return !1;
  const o = window.getComputedStyle(e);
  return !(o.display === "none" || o.visibility === "hidden");
}
function He(e, t = ie) {
  if (!e || !(e instanceof HTMLElement)) return null;
  const n = e.querySelectorAll(
    `${t.join(",")}:not([tabindex="-1"]):not([disabled]):not([inert]),[tabindex]:not([tabindex="-1"]):not([disabled]):not([inert])`
  );
  for (const r of n)
    if (Xt(r, t))
      return r;
  return null;
}
function it(e, t = ie) {
  return !e || !(e instanceof HTMLElement) ? null : Xt(e, t) ? e : He(e, t);
}
function Jt(e, t, n = ie) {
  if (!t || !(t instanceof HTMLElement)) return null;
  let r = t, o = null;
  for (; (r = e(r)) && !(o = it(r, n)); )
    ;
  return o;
}
function Zt(e, t = ie) {
  return Jt((n) => (n == null ? void 0 : n.nextElementSibling) ?? null, e, t);
}
function wr(e, t = ie) {
  return Jt((n) => (n == null ? void 0 : n.previousElementSibling) ?? null, e, t);
}
function Qt(e, t = ie) {
  if (!e || !(e instanceof HTMLElement)) return null;
  let n = e;
  for (; ; ) {
    const r = Zt(n, t);
    if (r) return r;
    if (n = (n == null ? void 0 : n.parentElement) ?? null, !n || n === e) return null;
  }
}
async function vr() {
  return new Promise((e) => {
    setTimeout(() => window.requestAnimationFrame(() => e()));
  });
}
const lt = "data-popup", et = "data-popup-id";
function zt(e) {
  let t = e;
  for (; t; ) {
    if (t != null && t.hasAttribute(lt)) return t;
    t = (t == null ? void 0 : t.parentElement) ?? null;
  }
  return null;
}
function _r(e, t) {
  if (!t || !e) return !1;
  const n = zt(t);
  if (!n) return !1;
  const r = n.getAttribute(lt);
  if (!r) return !1;
  if (e.getAttribute(et) === r) return !0;
  const o = zt(e);
  return o ? !!o.querySelector(`[${et}="${r}"]`) : !1;
}
function Se(e) {
  return e ? e.clientHeight && e.scrollHeight > e.clientHeight || e.tagName === "DIALOG" ? e.tagName === "HTML" ? window : e : Se(e.parentNode) : null;
}
const en = Kt({
  initialised: !1,
  open: !1,
  inDOM: !1,
  setInDOM: () => {
  },
  showPopup: () => {
  },
  hidePopup: () => {
  },
  togglePopup: () => {
  },
  hasClickTrigger: !1,
  hasKeypressTrigger: !1,
  hasFocusTrigger: !1,
  hasHoverTrigger: !1
});
function Ae() {
  return Ut(en);
}
function kr(e, t) {
  return JSON.stringify(e) === JSON.stringify(t);
}
function tn(e) {
  return (t) => t === e || t && kr(t, e) ? t : e;
}
const R = {
  Enter: "Enter",
  Space: " ",
  Tab: "Tab",
  Escape: "Escape",
  Down: "ArrowDown",
  Up: "ArrowUp",
  Left: "ArrowLeft",
  Right: "ArrowRight"
};
function De() {
  const e = document.getElementById("bp-portal-target");
  if (e) return e;
  const t = document.createElement("div");
  return t.id = "bp-portal-target", t.style.position = "absolute", t.setAttribute("role", "popup"), document.body.appendChild(t), t;
}
function Cr(e) {
  if (!e) return null;
  const { height: t, width: n } = e;
  return {
    height: t,
    width: n
  };
}
function jr({ triggerRect: e, id: t, onCloseTransitionEnd: n, onPopupLeave: r, children: o }) {
  const {
    popupRef: a,
    spyRef: i,
    preferredPopupPosition: s,
    alignPopup: l,
    hasHoverTrigger: u,
    Anchor: d,
    contentClassName: m,
    contentWrapperClassName: p,
    popupOpenWrapperClassName: h,
    anchorClassName: b,
    marginInPx: x
  } = Ae(), [y, g] = S(null), [w, v] = S(null), [A, E] = S(null), [T, $] = S(!1), { open: f, hidePopup: N, popupRef: D } = Ae();
  C(() => {
    if (!f) return $(!1);
    const L = window.requestAnimationFrame(() => {
      $(!0);
    });
    return () => window.cancelAnimationFrame(L);
  }, [f, $]);
  const B = _(() => {
    var M;
    const L = Cr((M = a == null ? void 0 : a.current) == null ? void 0 : M.getBoundingClientRect());
    g(tn(L));
  }, [a]), V = _(() => {
    const L = Se(De()) ?? document.body, Y = (L === window ? document.body : L).getBoundingClientRect();
    v(Y.width), E(Y.height);
  }, []), z = _(
    (L) => {
      var Y;
      if (L.key !== R.Escape) return;
      L.preventDefault();
      const M = (Y = i == null ? void 0 : i.current) == null ? void 0 : Y.nextElementSibling;
      M == null || M.focus(), N();
    },
    [N, i]
  );
  C(() => {
    const L = a == null ? void 0 : a.current;
    if (!L) return;
    const M = Wt(L);
    return M == null || M.forEach((Y, le) => {
      Y.addEventListener("keydown", z);
    }), () => {
      M == null || M.forEach((Y, le) => {
        Y.removeEventListener("keydown", z);
      });
    };
  }, [o, z, a]), ze(() => {
    B(), V();
  }, [B, V]);
  const j = _(() => {
    window.requestAnimationFrame(() => {
      B(), V();
    });
  }, [B, V]), O = _(
    (L) => {
      u && r(L);
    },
    [r, u]
  ), U = _(
    (L) => {
      var Y, le, ft;
      const M = (le = (Y = D == null ? void 0 : D.current) == null ? void 0 : Y.firstElementChild) == null ? void 0 : le.firstElementChild;
      if (L.target !== M && !((ft = a == null ? void 0 : a.current) != null && ft.contains(L.relatedTarget))) {
        if (_r(M, L.relatedTarget))
          return L.preventDefault();
        r(L);
      }
    },
    [r, D, a]
  );
  C(() => (window.addEventListener("resize", j), () => {
    window.removeEventListener("resize", j);
  }), [j]);
  const te = H(() => d ? 17 : 0, [d]);
  C(() => {
    if (f) return;
    const L = a == null ? void 0 : a.current;
    if (!h) return n();
    L == null || L.addEventListener("transitionend", n);
    const M = setTimeout(n, 300);
    return () => {
      clearTimeout(M), L == null || L.removeEventListener("transitionend", n);
    };
  }, [a, f, n, h]);
  const {
    x: he,
    y: ve,
    anchorOffsetX: _e,
    position: be,
    width: P
  } = H(
    () => zr({
      triggerRect: e,
      popupSize: y,
      bodyWidth: w,
      bodyHeight: A,
      anchorSize: te,
      preferredPopupPosition: s,
      alignPopup: l,
      originalMargin: x
    }),
    [e, y, w, A, te, s, l, x]
  );
  return Gt(
    /* @__PURE__ */ c.jsx(
      "div",
      {
        id: t,
        className: st.popupContainer,
        ref: a,
        onPointerLeave: O,
        onBlur: U,
        style: {
          transform: `translate3d(${he}px, ${ve}px, 0)`
        },
        children: /* @__PURE__ */ c.jsxs(
          "div",
          {
            className: k(
              p,
              h && { [h]: T }
            ),
            children: [
              d && be === G.BOTTOM && /* @__PURE__ */ c.jsx(d, { position: be, x: _e, className: b }),
              /* @__PURE__ */ c.jsx(
                "div",
                {
                  tabIndex: -1,
                  className: m,
                  style: {
                    ...l === re.JUSTIFY ? { minWidth: P, overflowX: "hidden" } : {}
                  },
                  [lt]: t,
                  children: o
                }
              ),
              d && be === G.TOP && /* @__PURE__ */ c.jsx(d, { position: be, x: _e, className: b })
            ]
          }
        )
      }
    ),
    De()
  );
}
function Tr(e, t, n) {
  C(() => {
    var d;
    const r = (d = n == null ? void 0 : n.current) == null ? void 0 : d.nextElementSibling;
    if (!r) return;
    n.current.setAttribute("id", "tooltip-spy");
    const o = He(r), a = o ?? r;
    r.setAttribute(et, e);
    const s = a.getAttribute("aria-roledescription") ?? xr(a) ?? "button";
    a.setAttribute("role", "button"), o || (a == null || a.setAttribute("tabindex", "0"), a == null || a.classList.add(st.nonFocusableOutline)), a.setAttribute("aria-roledescription", s);
    const l = a.getAttribute("aria-describedby");
    (l == null ? void 0 : l.includes(e)) || a.setAttribute("aria-describedby", `${yr(l, e)} tooltip-spy`);
  }, [t, e, n]);
}
function Nr(e, t, n) {
  if (!e) return null;
  const { left: r, top: o, bottom: a, width: i } = e;
  return {
    left: r,
    top: o,
    bottom: a,
    width: i,
    offsetX: n,
    offsetY: t
  };
}
function Lr({ children: e, content: t, id: n }) {
  const {
    showPopup: r,
    hidePopup: o,
    togglePopup: a,
    open: i,
    spyRef: s,
    popupRef: l,
    hasClickTrigger: u,
    hasFocusTrigger: d,
    hasHoverTrigger: m,
    hasKeypressTrigger: p,
    setInDOM: h
  } = Ae(), [b, x] = S(null), y = H(() => !!b, [b]);
  Tr(n, e, s);
  const g = _(() => {
    var j;
    const f = (j = s == null ? void 0 : s.current) == null ? void 0 : j.nextSibling;
    let N = f == null ? void 0 : f.getBoundingClientRect();
    N != null && N.height || (N = void 0);
    let D = 0, B = 0;
    const V = Se(De()) ?? window;
    if (V !== window) {
      const O = V;
      D = -O.getBoundingClientRect().top + O.scrollTop, B = -O.getBoundingClientRect().left + O.scrollLeft;
    }
    const z = Nr(N, D, B);
    x(tn(z)), h(!0);
  }, [h, s]), w = _(() => {
    x(null), h(!1);
  }, [h]), v = _(() => {
    y && g();
  }, [g, y]), A = _(
    (f) => {
      const N = l == null ? void 0 : l.current;
      if (f.relatedTarget instanceof Node && (N != null && N.contains(f.relatedTarget)))
        return f.preventDefault();
      o();
    },
    [o, l]
  ), E = _(
    (f) => {
      var N, D;
      if (f.relatedTarget instanceof Node && ((D = (N = s == null ? void 0 : s.current) == null ? void 0 : N.nextSibling) != null && D.contains(f.relatedTarget)))
        return f.preventDefault();
      o();
    },
    [o, s]
  ), T = _(
    (f) => {
      var D, B, V;
      const N = f.target instanceof Node;
      N && ((D = l == null ? void 0 : l.current) != null && D.contains(f.target)) || N && ((V = (B = s == null ? void 0 : s.current) == null ? void 0 : B.nextElementSibling) != null && V.contains(f.target)) || E(f);
    },
    [E, l, s]
  ), $ = _(
    (f) => {
      if (f.key === R.Enter || f.key === R.Space)
        return f.preventDefault(), a();
      if (f.key === R.Escape) return o();
    },
    [o, a]
  );
  return C(() => {
    if (u)
      return document.addEventListener("pointerdown", T), () => {
        document.removeEventListener("pointerdown", T);
      };
  }, [u, T]), C(() => {
    var N;
    if (!u) return;
    const f = (N = s == null ? void 0 : s.current) == null ? void 0 : N.nextElementSibling;
    return f == null || f.addEventListener("pointerdown", a), () => {
      f == null || f.removeEventListener("pointerdown", a);
    };
  }, [u, a, s, e]), C(() => {
    var N;
    if (!m) return;
    const f = (N = s == null ? void 0 : s.current) == null ? void 0 : N.nextElementSibling;
    return f == null || f.addEventListener("mouseover", r), f == null || f.addEventListener("mouseleave", A), () => {
      f == null || f.removeEventListener("mouseover", r), f == null || f.removeEventListener("mouseleave", A);
    };
  }, [m, A, r, s, e]), C(() => {
    var N;
    const f = (N = s == null ? void 0 : s.current) == null ? void 0 : N.nextElementSibling;
    return f == null || f.addEventListener("focusout", A), () => f == null ? void 0 : f.removeEventListener("focusout", A);
  }, [A, s, e]), C(() => {
    var N;
    if (!d) return;
    const f = (N = s == null ? void 0 : s.current) == null ? void 0 : N.nextElementSibling;
    return f == null || f.addEventListener("focus", r), f == null || f.addEventListener("focusin", r), () => {
      f == null || f.removeEventListener("focus", r), f == null || f.removeEventListener("focusin", r);
    };
  }, [d, r, e, s]), C(() => {
    var N;
    if (!p) return;
    const f = (N = s == null ? void 0 : s.current) == null ? void 0 : N.nextElementSibling;
    return f == null || f.addEventListener("keydown", $), () => {
      f == null || f.removeEventListener("keydown", $);
    };
  }, [p, $, s, e]), C(() => {
    if (!i) return;
    window.addEventListener("resize", v, { passive: !0 });
    const f = Se(De()) ?? window;
    return f.addEventListener("scroll", v, { passive: !0 }), () => {
      window.removeEventListener("resize", v), f.removeEventListener("scroll", v);
    };
  }, [i, v]), ze(() => {
    v();
  }, [e, v]), C(() => {
    i && g();
  }, [i, g]), /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx("div", { ref: s, className: st.spyElement }),
    e,
    y && /* @__PURE__ */ c.jsx(
      jr,
      {
        triggerRect: b,
        onCloseTransitionEnd: w,
        id: n,
        onPopupLeave: E,
        children: t
      }
    )
  ] });
}
function nn({
  children: e,
  content: t,
  id: n,
  triggerEvents: r = ["hover", "focus"],
  inactive: o,
  ...a
}) {
  const [i, s] = S(!1), [l, u] = S(!1), [d, m] = S(!1), p = I(null), h = I(null), b = Ae(), x = Fe(), y = H(() => n ?? x, [n]), g = H(() => r == null ? void 0 : r.includes("click"), [r]), w = H(() => r == null ? void 0 : r.includes("focus"), [r]), v = H(() => r == null ? void 0 : r.includes("hover"), [r]), A = H(() => r == null ? void 0 : r.includes("keypress"), [r]), E = _(() => {
    u(!1);
  }, []), T = _(() => {
    u(!0);
  }, []), $ = _(() => {
    u((f) => !f);
  }, []);
  return C(() => (s(!0), () => {
    s(!1);
  }), []), !i || o ? e : /* @__PURE__ */ c.jsx(
    en.Provider,
    {
      value: {
        open: l,
        showPopup: T,
        hidePopup: E,
        togglePopup: $,
        spyRef: h,
        popupRef: p,
        hasClickTrigger: g,
        hasHoverTrigger: v,
        hasFocusTrigger: w,
        hasKeypressTrigger: A,
        inDOM: d,
        setInDOM: m,
        initialised: !0,
        parentContext: b,
        ...a
      },
      children: /* @__PURE__ */ c.jsx(Lr, { content: t, id: y, children: e })
    }
  );
}
function zr({
  triggerRect: e,
  popupSize: t,
  bodyWidth: n,
  bodyHeight: r,
  originalMargin: o = 20,
  anchorSize: a = 17,
  preferredPopupPosition: i = G.TOP,
  alignPopup: s = re.CENTER
}) {
  let l = 0, u = 0, d = 0, m = 0, p = i, h = (t == null ? void 0 : t.width) ?? 0;
  if (!e || !t || !n || !r)
    return { x: l, y: u, anchorOffsetX: m, position: p, width: h };
  let b = 0, x = t.width / 2;
  const y = e.width / 2;
  s === re.CENTER ? l = e.left + e.offsetX - x + y : s === re.LEFT || s === re.JUSTIFY ? (l = e.left + e.offsetX, s === re.JUSTIFY && (h = e.width, x = y)) : s === re.RIGHT && (l = e.left + e.offsetX + e.width - h);
  const g = t.width > n ? 0 : Math.min(o, (n - h) / 2);
  if (b = l, d = l + t.width, l < g ? l = g : d > n - g && (l -= d - (n - g)), a) {
    m = b - l + x - a;
    const w = m + 2 * a - h;
    if (w > 0) {
      const v = Math.min(w, g);
      l += v, m -= v;
    }
  }
  return i === G.TOP ? (u = e.top + e.offsetY - t.height, u < Math.abs(e.offsetY) && (p = G.BOTTOM, u = e.bottom)) : (u = e.bottom + e.offsetY, u + t.height > r + e.offsetY && (p = G.TOP, u = e.top + e.offsetY - t.height)), { x: l, y: u, anchorOffsetX: m, position: p, width: h };
}
const Sr = ["click", "keypress"];
function Ya({
  children: e,
  style: t,
  className: n,
  id: r
}) {
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      id: r,
      style: t,
      className: k(pt.selectContainer, pt.select, me.dropdownTriggerButton, n),
      type: "button",
      children: [
        e,
        /* @__PURE__ */ c.jsx(oe, { name: "chevronDown" })
      ]
    }
  );
}
function Ga({
  children: e,
  className: t,
  required: n,
  hint: r,
  id: o
}) {
  return /* @__PURE__ */ c.jsx("div", { children: e ? /* @__PURE__ */ c.jsxs("label", { htmlFor: o, className: k(mt.label, t), children: [
    /* @__PURE__ */ c.jsxs("div", { children: [
      e,
      n && /* @__PURE__ */ c.jsx("span", { "aria-label": "(required)", children: "*" })
    ] }),
    r ? /* @__PURE__ */ c.jsx("div", { className: k(mt.hint), children: r }) : null
  ] }) : null });
}
function Ar({ children: e, className: t }) {
  return /* @__PURE__ */ c.jsx("ul", { className: k(me.dropdownMenu, t), children: e });
}
function Ir({
  children: e,
  style: t,
  className: n
}) {
  const r = I(null), { preferredPopupPosition: o, hidePopup: a, parentContext: i, spyRef: s } = we(), l = _(
    (u) => {
      var p, h;
      const d = i && o, m = d && rn[d].close;
      if (u.key === R.Down || u.key === R.Up) {
        u.preventDefault();
        const b = u.key === R.Up ? wr(r.current) : Zt(r.current);
        b == null || b.focus();
        return;
      }
      u.key === m && (u.preventDefault(), (h = it((p = s == null ? void 0 : s.current) == null ? void 0 : p.nextElementSibling)) == null || h.focus(), a()), u.key === R.Enter && u.target instanceof HTMLElement && "click" in u.target && u.target.click();
    },
    [a, i, o, s]
  );
  return C(() => {
    const u = He(r.current);
    if (u)
      return u.addEventListener("keydown", l), u.addEventListener("click", a), () => {
        u.removeEventListener("keydown", l), u.removeEventListener("click", a);
      };
  }, [a, l]), /* @__PURE__ */ c.jsx("li", { ref: r, style: t, className: k(me.dropdownMenuItem, n), children: e });
}
function Pr() {
  return /* @__PURE__ */ c.jsx("li", { className: me.dropdownMenuSeparator });
}
const rn = {
  [G.BOTTOM]: { open: R.Down, close: R.Down },
  [G.TOP]: { open: R.Up, close: R.Down },
  [G.RIGHT]: { open: R.Right, close: R.Left },
  [G.LEFT]: { open: R.Left, close: R.Right }
};
function Mr({ children: e }) {
  const { spyRef: t, popupRef: n, showPopup: r, preferredPopupPosition: o } = we(), a = _(
    (i) => {
      const s = o ?? G.BOTTOM, l = rn[s].open;
      i.key === l && (i.preventDefault(), r(), vr().then(() => {
        var d;
        let u = He(n == null ? void 0 : n.current);
        if (u) {
          u.focus();
          return;
        }
        i.key === R.Tab && (u = Qt((d = t == null ? void 0 : t.current) == null ? void 0 : d.nextElementSibling), u == null || u.focus());
      }));
    },
    [n, o, r, t]
  );
  return C(() => {
    var s;
    const i = (s = t == null ? void 0 : t.current) == null ? void 0 : s.nextElementSibling;
    if (i)
      return i.addEventListener("keydown", a), () => i.removeEventListener("keydown", a);
  }, [a, t]), e;
}
function Or({ children: e }) {
  const { spyRef: t, popupRef: n, hidePopup: r, open: o } = we(), a = _(
    (s) => {
      var l, u;
      s.key !== R.Tab || !s.shiftKey || (s.preventDefault(), (u = it((l = t == null ? void 0 : t.current) == null ? void 0 : l.nextElementSibling)) == null || u.focus(), r());
    },
    [t, r]
  ), i = _(
    (s) => {
      var u;
      if (s.key !== R.Tab || s.shiftKey) return;
      s.preventDefault();
      const l = Qt((u = t == null ? void 0 : t.current) == null ? void 0 : u.nextElementSibling);
      l == null || l.focus();
    },
    [t]
  );
  return C(() => {
    const s = n == null ? void 0 : n.current;
    if (!s) return;
    const l = Wt(s);
    if (!l || !l.length) return;
    const u = l.item(0), d = l.item(l.length - 1);
    return u.addEventListener("keydown", a), d.addEventListener("keydown", i), () => {
      u.removeEventListener("keydown", a), d.removeEventListener("keydown", i);
    };
  }, [a, i, t, n, e, o]), e;
}
function on({
  trigger: e,
  children: t,
  className: n,
  alignContent: r = re.JUSTIFY,
  wrapperClassName: o,
  anchorClassName: a,
  preferredPopupPosition: i,
  marginInPx: s,
  Anchor: l
}) {
  const { parentContext: u } = we(), d = i ?? (u ? u.preferredPopupPosition ?? G.RIGHT : G.BOTTOM);
  return /* @__PURE__ */ c.jsx(
    nn,
    {
      content: /* @__PURE__ */ c.jsx(Or, { children: t }),
      contentClassName: k(me.dropdownContent, n),
      contentWrapperClassName: k(me.scaleTransition, o),
      popupOpenWrapperClassName: me.scaleTransitionOpen,
      triggerEvents: Sr,
      preferredPopupPosition: d,
      alignPopup: r,
      anchorClassName: a,
      Anchor: l,
      marginInPx: s,
      children: /* @__PURE__ */ c.jsx(Mr, { children: e })
    }
  );
}
function we() {
  const {
    showPopup: e,
    hidePopup: t,
    togglePopup: n,
    spyRef: r,
    popupRef: o,
    inDOM: a,
    parentContext: i,
    alignPopup: s,
    preferredPopupPosition: l
  } = Ae(), u = i && i.initialised ? i : void 0;
  return {
    open: a,
    showPopup: e,
    hidePopup: t,
    togglePopup: n,
    spyRef: r,
    popupRef: o,
    parentContext: u,
    alignPopup: s,
    preferredPopupPosition: l
  };
}
function qe() {
  return (qe = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function ut(e, t) {
  if (e == null) return {};
  var n, r, o = {}, a = Object.keys(e);
  for (r = 0; r < a.length; r++) t.indexOf(n = a[r]) >= 0 || (o[n] = e[n]);
  return o;
}
function $e(e) {
  var t = I(e), n = I(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var Ie = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, Le = function(e) {
  return "touches" in e;
}, tt = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, St = function(e, t, n) {
  var r = e.getBoundingClientRect(), o = Le(t) ? function(a, i) {
    for (var s = 0; s < a.length; s++) if (a[s].identifier === i) return a[s];
    return a[0];
  }(t.touches, n) : t;
  return { left: Ie((o.pageX - (r.left + tt(e).pageXOffset)) / r.width), top: Ie((o.pageY - (r.top + tt(e).pageYOffset)) / r.height) };
}, At = function(e) {
  !Le(e) && e.preventDefault();
}, an = W.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = ut(e, ["onMove", "onKey"]), o = I(null), a = $e(t), i = $e(n), s = I(null), l = I(!1), u = H(function() {
    var h = function(y) {
      At(y), (Le(y) ? y.touches.length > 0 : y.buttons > 0) && o.current ? a(St(o.current, y, s.current)) : x(!1);
    }, b = function() {
      return x(!1);
    };
    function x(y) {
      var g = l.current, w = tt(o.current), v = y ? w.addEventListener : w.removeEventListener;
      v(g ? "touchmove" : "mousemove", h), v(g ? "touchend" : "mouseup", b);
    }
    return [function(y) {
      var g = y.nativeEvent, w = o.current;
      if (w && (At(g), !function(A, E) {
        return E && !Le(A);
      }(g, l.current) && w)) {
        if (Le(g)) {
          l.current = !0;
          var v = g.changedTouches || [];
          v.length && (s.current = v[0].identifier);
        }
        w.focus(), a(St(w, g, s.current)), x(!0);
      }
    }, function(y) {
      var g = y.which || y.keyCode;
      g < 37 || g > 40 || (y.preventDefault(), i({ left: g === 39 ? 0.05 : g === 37 ? -0.05 : 0, top: g === 40 ? 0.05 : g === 38 ? -0.05 : 0 }));
    }, x];
  }, [i, a]), d = u[0], m = u[1], p = u[2];
  return C(function() {
    return p;
  }, [p]), W.createElement("div", qe({}, r, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: o, onKeyDown: m, tabIndex: 0, role: "slider" }));
}), cn = function(e) {
  return e.filter(Boolean).join(" ");
}, sn = function(e) {
  var t = e.color, n = e.left, r = e.top, o = r === void 0 ? 0.5 : r, a = cn(["react-colorful__pointer", e.className]);
  return W.createElement("div", { className: a, style: { top: 100 * o + "%", left: 100 * n + "%" } }, W.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, pe = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, Er = function(e) {
  var t = e.s, n = e.v, r = e.a, o = (200 - t) * n / 100;
  return { h: pe(e.h), s: pe(o > 0 && o < 200 ? t * n / 100 / (o <= 100 ? o : 200 - o) * 100 : 0), l: pe(o / 2), a: pe(r, 2) };
}, nt = function(e) {
  var t = Er(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
};
W.memo(function(e) {
  var t = e.hue, n = e.onChange, r = cn(["react-colorful__hue", e.className]);
  return W.createElement("div", { className: r }, W.createElement(an, { onMove: function(o) {
    n({ h: 360 * o.left });
  }, onKey: function(o) {
    n({ h: Ie(t + 360 * o.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": pe(t), "aria-valuemax": "360", "aria-valuemin": "0" }, W.createElement(sn, { className: "react-colorful__hue-pointer", left: t / 360, color: nt({ h: t, s: 100, v: 100, a: 1 }) })));
});
W.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: nt({ h: t.h, s: 100, v: 100, a: 1 }) };
  return W.createElement("div", { className: "react-colorful__saturation", style: r }, W.createElement(an, { onMove: function(o) {
    n({ s: 100 * o.left, v: 100 - 100 * o.top });
  }, onKey: function(o) {
    n({ s: Ie(t.s + 100 * o.left, 0, 100), v: Ie(t.v - 100 * o.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + pe(t.s) + "%, Brightness " + pe(t.v) + "%" }, W.createElement(sn, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: nt(t) })));
});
var Dr = /^#?([0-9A-F]{3,8})$/i, $r = function(e) {
  var t = e.color, n = t === void 0 ? "" : t, r = e.onChange, o = e.onBlur, a = e.escape, i = e.validate, s = e.format, l = e.process, u = ut(e, ["color", "onChange", "onBlur", "escape", "validate", "format", "process"]), d = S(function() {
    return a(n);
  }), m = d[0], p = d[1], h = $e(r), b = $e(o), x = _(function(g) {
    var w = a(g.target.value);
    p(w), i(w) && h(l ? l(w) : w);
  }, [a, l, i, h]), y = _(function(g) {
    i(g.target.value) || p(a(n)), b(g);
  }, [n, a, i, b]);
  return C(function() {
    p(a(n));
  }, [n, a]), W.createElement("input", qe({}, u, { value: s ? s(m) : m, spellCheck: "false", onChange: x, onBlur: y }));
}, It = function(e) {
  return "#" + e;
}, Br = function(e) {
  var t = e.prefixed, n = e.alpha, r = ut(e, ["prefixed", "alpha"]), o = _(function(i) {
    return i.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
  }, [n]), a = _(function(i) {
    return function(s, l) {
      var u = Dr.exec(s), d = u ? u[1].length : 0;
      return d === 3 || d === 6 || !!l && d === 4 || !!l && d === 8;
    }(i, n);
  }, [n]);
  return W.createElement($r, qe({}, r, { escape: o, format: t ? It : void 0, process: It, validate: a }));
};
const Rr = {
  "betterplace-dimension-0": "1rem",
  "betterplace-dimension-1": "1.25rem",
  "betterplace-dimension-2": "1.5rem",
  "betterplace-dimension-3": "2rem",
  "betterplace-dimension-4": "3rem",
  "betterplace-dimension-5": "4rem",
  "betterplace-dimension-6": "5rem",
  "betterplace-dimension-7": "6.25rem",
  "betterplace-dimension-8": "12.5rem",
  "betterplace-dimension-9": "20rem",
  "betterplace-dimension-10": "30rem",
  "betterplace-dimension--1": "0.75rem",
  "betterplace-dimension--2": "0.5rem",
  "betterplace-dimension--3": "0.25rem",
  "betterplace-dimension--4": "0.125rem",
  "betterplace-dimension--5": "0.0625rem",
  "betterplace-dimension-none": "0rem",
  "betterplace-dimension-negative-1": "-0.75rem",
  "betterplace-dimension-negative-2": "-0.5rem",
  "betterplace-dimension-negative-3": "-0.25rem",
  "betterplace-dimension-negative-4": "-0.125rem",
  "betterplace-dimension-negative-5": "-0.0625rem",
  "betterplace-opacity-low": "10%",
  "betterplace-opacity-md": "50%",
  "betterplace-opacity-high": "90%",
  "betterplace-letter-spacing-0": "0%",
  "betterplace-letter-spacing-increased": "150%",
  "betterplace-letter-spacing-decreased": "-5%",
  "betterplace-paragraph-spacing-0": "0",
  "betterplace-paragraph-spacing-md": "12rem",
  "betterplace-paragraph-spacing-sm": "8rem",
  "betterplace-color-gray-100": "#f8f8f8",
  "betterplace-color-gray-200": "#eeeeee",
  "betterplace-color-gray-300": "#cccccc",
  "betterplace-color-gray-400": "#acacac",
  "betterplace-color-gray-500": "#919191",
  "betterplace-color-gray-600": "#7b7b7b",
  "betterplace-color-gray-700": "#636363",
  "betterplace-color-gray-800": "#3f3f3f",
  "betterplace-color-gray-900": "#282828",
  "betterplace-color-green-100": "#f5fccc",
  "betterplace-color-green-200": "#eaf99a",
  "betterplace-color-green-300": "#d6ef66",
  "betterplace-color-green-400": "#bedf40",
  "betterplace-color-green-500": "#9ecb0a",
  "betterplace-color-green-600": "#85ac1c",
  "betterplace-color-green-700": "#549205",
  "betterplace-color-green-800": "#357c00",
  "betterplace-color-green-900": "#2a5807",
  "betterplace-color-purple-100": "#f7dae8",
  "betterplace-color-purple-200": "#f0b7d8",
  "betterplace-color-purple-300": "#d387ba",
  "betterplace-color-purple-400": "#a75c96",
  "betterplace-color-purple-500": "#833c79",
  "betterplace-color-purple-600": "#6d2c64",
  "betterplace-color-purple-700": "#612058",
  "betterplace-color-purple-800": "#4d1a43",
  "betterplace-color-purple-900": "#381835",
  "betterplace-color-teal-100": "#e4fbee",
  "betterplace-color-teal-200": "#c9f7e2",
  "betterplace-color-teal-300": "#a7e7d0",
  "betterplace-color-teal-400": "#88d0bd",
  "betterplace-color-teal-500": "#60b2a4",
  "betterplace-color-teal-600": "#309b89",
  "betterplace-color-teal-700": "#2b8475",
  "betterplace-color-teal-800": "#1e6761",
  "betterplace-color-teal-900": "#114e47",
  "betterplace-color-yellow-100": "#fff4d2",
  "betterplace-color-yellow-200": "#fbe8af",
  "betterplace-color-yellow-300": "#f9da7c",
  "betterplace-color-yellow-400": "#f6ce46",
  "betterplace-color-yellow-500": "#f3b700",
  "betterplace-color-yellow-600": "#f3a900",
  "betterplace-color-yellow-700": "#f39600",
  "betterplace-color-yellow-800": "#d86c00",
  "betterplace-color-yellow-900": "#c44400",
  "betterplace-color-red-100": "#fee2e2",
  "betterplace-color-red-200": "#ffc4c4",
  "betterplace-color-red-300": "#fca5a5",
  "betterplace-color-red-400": "#f87171",
  "betterplace-color-red-500": "#ef4444",
  "betterplace-color-red-600": "#dc2626",
  "betterplace-color-red-700": "#d32b43",
  "betterplace-color-red-800": "#b11b3e",
  "betterplace-color-red-900": "#931c38",
  "betterplace-color-light": "#ffffff",
  "betterplace-color-darkness": "#000000",
  "betterplace-color-blue-pruple-500": "#7d83ff",
  "betterplace-color-blue-purple-600": "#4557cb",
  "betterplace-color-blue-dark": "#245d8c",
  "betterplace-color-red-alt": "#fc440f",
  "betterplace-color-cream": "#fbfbf2",
  "betterplace-color-opacity-white-40": "rgba(255, 255, 255, 0.4)",
  "betterplace-color-opacity-white-70": "rgba(255, 255, 255, 0.7)",
  "betterplace-color-opacity-black-10": "rgba(0, 0, 0, 0.1)",
  "betterplace-color-opacity-black-20": "rgba(0, 0, 0, 0.2)",
  "betterplace-color-opacity-black-30": "rgba(0, 0, 0, 0.3)",
  "betterplace-color-opacity-black-40": "rgba(0, 0, 0, 0.4)",
  "betterplace-color-opacity-black-50": "rgba(0, 0, 0, 0.5)",
  "betterplace-color-opacity-black-60": "rgba(0, 0, 0, 0.6)",
  "betterplace-color-opacity-black-70": "rgba(0, 0, 0, 0.7)",
  "betterplace-color-opacity-black-80": "rgba(0, 0, 0, 0.8)",
  "betterplace-color-opacity-black-90": "rgba(0, 0, 0, 0.9)",
  "betterplace-me-color-orange-500": "#ff854d",
  "betterplace-me-color-orange-600": "#db6038",
  "betterplace-me-color-orange-800": "#6f1f06",
  "betterplace-me-color-blue-100": "#e0f4f9",
  "betterplace-me-color-blue-500": "#00a0c8",
  "betterplace-me-color-blue-700": "#005d90",
  "betterplace-me-color-green-special": "#ebf2e6",
  "betterplace-external-color-blue-facebook": "#0165e1",
  "betterplace-external-color-blue-messenger": "#0695ff",
  "betterplace-external-color-pink-instagram": "#e1306c",
  "betterplace-external-color-blue-linkedin": "#0a66c2",
  "betterplace-external-color-red-sparkasse": "#ff0000",
  "betterplace-external-color-whatsapp": "#28d146",
  "betterplace-font-families-fira-sans": "Fira Sans",
  "betterplace-font-weights-regular": 400,
  "betterplace-font-weights-bold": 700,
  "betterplace-text-case-none": "none",
  "betterplace-text-case-capitalize": "capitalize",
  "betterplace-text-decoration-none": "none",
  "betterplace-text-decoration-underline": "underline",
  "betterplace-line-heights-xs": 1.1,
  "betterplace-line-heights-sm": 1.2,
  "betterplace-line-heights-base": 1.5,
  "betterplace-variables-min-font-size": "16rem",
  "betterplace-variables-max-font-size": "18rem",
  "betterplace-variables-fluid-root-font-size": "min(max(16rem + (1440rem - 360rem) * (1.125 - 1) / (90 - 22.5), 16rem), 18rem)",
  "betterplace-variables-font-size-scale-ratio": "1.1892rem",
  "betterplace-variables-width-of-zero-glyph": "0.5583",
  "betterplace-units-ch": "min(max(16rem + (1440rem - 360rem) * (1.125 - 1) / (90 - 22.5), 16rem), 18rem) * 0.5583",
  "betterplace-units-rem": "min(max(16rem + (1440rem - 360rem) * (1.125 - 1) / (90 - 22.5), 16rem), 18rem)",
  "betterplace-font-size-0": "1rem",
  "betterplace-font-size-1": "1.189rem",
  "betterplace-font-size-2": "1.414rem",
  "betterplace-font-size-3": "1.682rem",
  "betterplace-font-size-4": "2rem",
  "betterplace-font-size-5": "2.378rem",
  "betterplace-font-size-6": "2.828rem",
  "betterplace-font-size-7": "3.363rem",
  "betterplace-font-size-8": "4rem",
  "betterplace-font-size-9": "4.757rem",
  "betterplace-font-size-10": "5.657rem",
  "betterplace-font-size--3": "0.595rem",
  "betterplace-font-size--2": "0.707rem",
  "betterplace-font-size--1": "0.841rem",
  "betterplace-measure-2xs": "25ch",
  "betterplace-measure-xs": "36ch",
  "betterplace-measure-sm": "49ch",
  "betterplace-measure-md": "64ch",
  "betterplace-measure-lg": "81ch",
  "betterplace-measure-xl": "100ch",
  "betterplace-measure-2xl": "121ch",
  "betterplace-viewport-width": "1440rem",
  "betterplace-viewport-min": "360rem",
  "betterplace-viewport-max": "1440rem",
  "betterplace-typography-xs": {},
  "betterplace-typography-sm": {},
  "betterplace-typography-sm-narrow": {},
  "betterplace-typography-sm-bold": {},
  "betterplace-typography-sm-bold-narrow": {},
  "betterplace-typography-base": {},
  "betterplace-typography-base-bold": {},
  "betterplace-typography-lg": {},
  "betterplace-typography-lg-bold": {},
  "betterplace-typography-xl": {},
  "betterplace-typography-xl-bold": {},
  "betterplace-typography-2xl-bold": {},
  "betterplace-typography-3xl-bold": {},
  "betterplace-typography-4xl-bold": {},
  "betterplace-sizing-fix-1": "20rem",
  "betterplace-sizing-fix-2": "23.4375rem",
  "betterplace-sizing-fix-3": "48.75rem",
  "betterplace-sizing-fix-4": "60rem",
  "betterplace-sizing-fix-5": "52.875rem",
  "betterplace-sizing-fix-6": "90rem",
  "betterplace-shadow-outer-neutral-soft-1": {
    x: "0rem",
    y: "0.0625rem",
    blur: "0.125rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-2": {
    x: "0rem",
    y: "0.125rem",
    blur: "0.25rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-3": {
    x: "0rem",
    y: "0.25rem",
    blur: "0.5rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-4": {
    x: "0rem",
    y: "0.5rem",
    blur: "1rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-5": {
    x: "0rem",
    y: "0.5rem",
    blur: "1.5rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-6": {
    x: "0rem",
    y: "0.75rem",
    blur: "3rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-hard-1": {
    x: "0rem",
    y: "0rem",
    blur: "0.0625rem",
    color: "rgba(0, 0, 0, 0.5)"
  },
  "betterplace-shadow-outer-neutral-hard-2": {
    x: "0rem",
    y: "0rem",
    blur: "0.125rem",
    color: "rgba(0, 0, 0, 0.5)"
  },
  "betterplace-shadow-outer-neutral-hard-3": {
    x: "0rem",
    y: "0rem",
    blur: "0.25rem",
    color: "rgba(0, 0, 0, 0.5)"
  },
  "betterplace-shadow-outer-neutral-hard-4": {
    x: "0rem",
    y: "0rem",
    blur: "0.5rem",
    color: "rgba(0, 0, 0, 0.5)"
  },
  "betterplace-shadow-outer-neutral-hard-5": {
    x: "0rem",
    y: "0rem",
    blur: "0.75rem",
    color: "rgba(0, 0, 0, 0.5)"
  },
  "betterplace-shadow-outer-neutral-hard-6": {
    x: "0rem",
    y: "0rem",
    blur: "1.25rem",
    color: "rgba(0, 0, 0, 0.5)"
  },
  "betterplace-shadow-outer-green-hard-1": {
    x: "0rem",
    y: "0rem",
    blur: "0.0625rem",
    color: "#2a5807"
  },
  "betterplace-shadow-outer-green-hard-2": {
    x: "0rem",
    y: "0rem",
    blur: "0.125rem",
    color: "#2a5807"
  },
  "betterplace-shadow-outer-green-hard-3": {
    x: "0rem",
    y: "0rem",
    blur: "0.25rem",
    color: "#2a5807"
  },
  "betterplace-shadow-outer-green-hard-4": {
    x: "0rem",
    y: "0rem",
    blur: "0.5rem",
    color: "#2a5807"
  },
  "betterplace-shadow-outer-green-hard-5": {
    x: "0rem",
    y: "0rem",
    blur: "0.75rem",
    color: "#2a5807"
  },
  "betterplace-shadow-outer-green-hard-6": {
    x: "0rem",
    y: "0rem",
    blur: "1.25rem",
    color: "#2a5807"
  },
  "betterplace-shadow-outer-red-hard-1": {
    x: "0rem",
    y: "0rem",
    blur: "0.0625rem",
    color: "#d32b43"
  },
  "betterplace-shadow-outer-red-hard-2": {
    x: "0rem",
    y: "0rem",
    blur: "0.125rem",
    color: "#d32b43"
  },
  "betterplace-shadow-outer-red-hard-3": {
    x: "0rem",
    y: "0rem",
    blur: "0.25rem",
    color: "#d32b43"
  },
  "betterplace-shadow-outer-red-hard-4": {
    x: "0rem",
    y: "0rem",
    blur: "0.5rem",
    color: "#d32b43"
  },
  "betterplace-shadow-outer-red-hard-5": {
    x: "0rem",
    y: "0rem",
    blur: "0.75rem",
    color: "#d32b43"
  },
  "betterplace-shadow-outer-red-hard-6": {
    x: "0rem",
    y: "0rem",
    blur: "1.25rem",
    color: "#d32b43"
  },
  "betterplace-shadow-outer-neutral-soft-upwards-1": {
    x: "0rem",
    y: "-0.0625rem",
    blur: "0.125rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-upwards-2": {
    x: "0rem",
    y: "-0.125rem",
    blur: "0.25rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-upwards-3": {
    x: "0rem",
    y: "-0.25rem",
    blur: "0.5rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-upwards-4": {
    x: "0rem",
    y: "-0.5rem",
    blur: "1rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-upwards-5": {
    x: "0rem",
    y: "-0.5rem",
    blur: "1.5rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-outer-neutral-soft-upwards-6": {
    x: "0rem",
    y: "-0.75rem",
    blur: "3rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-inner-neutral-1": {
    x: "0rem",
    y: "0.0625rem",
    blur: "0.125rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-inner-neutral-2": {
    x: "0rem",
    y: "0.125rem",
    blur: "0.25rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-inner-neutral-3": {
    x: "0rem",
    y: "0.25rem",
    blur: "0.5rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-inner-neutral-4": {
    x: "0rem",
    y: "0.5rem",
    blur: "1rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-inner-neutral-5": {
    x: "0rem",
    y: "0.5rem",
    blur: "1.5rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-inner-neutral-6": {
    x: "0rem",
    y: "0.75rem",
    blur: "3rem",
    color: "rgba(0, 0, 0, 0.2)"
  },
  "betterplace-shadow-inner-red-1": {
    x: "0rem",
    y: "0.0625rem",
    blur: "0.125rem",
    color: "#931c38"
  },
  "betterplace-shadow-inner-red-2": {
    x: "0rem",
    y: "0.125rem",
    blur: "0.25rem",
    color: "#931c38"
  },
  "betterplace-shadow-inner-red-3": {
    x: "0rem",
    y: "0.25rem",
    blur: "0.5rem",
    color: "#931c38"
  },
  "betterplace-shadow-inner-red-4": {
    x: "0rem",
    y: "0.5rem",
    blur: "1rem",
    color: "#931c38"
  },
  "betterplace-shadow-inner-red-5": {
    x: "0rem",
    y: "0.5rem",
    blur: "1.5rem",
    color: "#931c38"
  },
  "betterplace-shadow-inner-red-6": {
    x: "0rem",
    y: "0.75rem",
    blur: "3rem",
    color: "#931c38"
  },
  "betterplace-shadow-inner-green-1": {
    x: "0rem",
    y: "0.0625rem",
    blur: "0.125rem",
    color: "#2a5807"
  },
  "betterplace-shadow-inner-green-2": {
    x: "0rem",
    y: "0.125rem",
    blur: "0.25rem",
    color: "#2a5807"
  },
  "betterplace-shadow-inner-green-3": {
    x: "0rem",
    y: "0.25rem",
    blur: "0.5rem",
    color: "#2a5807"
  },
  "betterplace-shadow-inner-green-4": {
    x: "0rem",
    y: "0.5rem",
    blur: "1rem",
    color: "#2a5807"
  },
  "betterplace-shadow-inner-green-5": {
    x: "0rem",
    y: "0.5rem",
    blur: "1.5rem",
    color: "#2a5807"
  },
  "betterplace-shadow-inner-green-6": {
    x: "0rem",
    y: "0.75rem",
    blur: "3rem",
    color: "#2a5807"
  }
}, Fr = (e) => e.substring(1, 3) === "00" && e.length === 9 ? "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABlBMVEX////Z5exdL3Q7AAAAGklEQVQY02NgAAFGRkaa0gzo4gzo6hgGiTsANBAAYf1ZdsIAAAAASUVORK5CYII=')" : e;
function X(e) {
  const t = Rr[e];
  return typeof t != "object" && typeof t != "number" ? t : "#";
}
const ln = ee(function({
  onClick: t,
  color: n,
  triggerSwatch: r = !1,
  className: o,
  "aria-describedby": a,
  ...i
}, s) {
  return /* @__PURE__ */ c.jsxs(
    "button",
    {
      ...i,
      className: k(ne.swatch, o, {
        [ne.activeSwatch]: r
      }),
      onClick: t,
      ref: s,
      type: "button",
      "aria-roledescription": r ? "colour well" : "button",
      "aria-describedby": a,
      children: [
        /* @__PURE__ */ c.jsx(
          "div",
          {
            style: {
              background: Fr(n)
            },
            className: ne.swatchInner
          }
        ),
        /* @__PURE__ */ c.jsx("span", { className: "sr-only", children: n })
      ]
    }
  );
});
function Hr({
  color: e,
  presetColors: t,
  onChange: n,
  hexInputLabel: r,
  label: o,
  id: a,
  classNames: i,
  error: s,
  ...l
}) {
  const u = Fe(), d = a || l.name || u, m = I(null), p = I(null);
  return /* @__PURE__ */ c.jsx(
    Ht,
    {
      name: l.name,
      id: d,
      label: o,
      error: s,
      className: k(ne.picker, i == null ? void 0 : i.label),
      errorDisplay: "border",
      children: /* @__PURE__ */ c.jsx(
        on,
        {
          className: ne.dropdown,
          trigger: /* @__PURE__ */ c.jsx(
            ln,
            {
              ...l,
              "aria-describedby": `label-${d}`,
              id: d,
              color: e,
              ref: p,
              triggerSwatch: !0,
              className: k(i == null ? void 0 : i.trigger, { [ne.errorSwatch]: s })
            }
          ),
          Anchor: ct,
          children: /* @__PURE__ */ c.jsx("div", { className: ne.popover, ref: m, children: /* @__PURE__ */ c.jsxs("div", { className: ne.pickerSwatches, children: [
            t.map((h) => /* @__PURE__ */ Yt(
              qr,
              {
                ...l,
                key: h,
                color: h,
                onClick: () => {
                  n(h);
                },
                className: k({
                  [ne.activeSwatch]: h === e,
                  [ne.inactiveSwatch]: h !== e
                })
              }
            )),
            /* @__PURE__ */ c.jsx(Kr, { id: d, color: e, onChange: n, alpha: !0, prefixed: !0, className: ne.input })
          ] }) })
        }
      )
    }
  );
}
function qr({ onClick: e, ...t }) {
  const { hidePopup: n } = we(), r = _(
    (o) => {
      n(), e == null || e(o);
    },
    [e, n]
  );
  return /* @__PURE__ */ c.jsx(ln, { ...t, onClick: r });
}
function Kr({ onKeyDown: e, ...t }) {
  const { hidePopup: n } = we(), r = _(
    (o) => {
      e == null || e(o), o.key === "Enter" && n();
    },
    [e, n]
  );
  return /* @__PURE__ */ c.jsx(Br, { ...t, onKeyDown: r });
}
function Va({
  onColorChange: e,
  transparentOption: t = !1,
  value: n,
  hexInputLabel: r,
  label: o,
  ...a
}) {
  const i = [
    X("betterplace-color-light"),
    X("betterplace-color-green-500"),
    X("betterplace-color-green-700"),
    X("betterplace-color-green-900"),
    X("betterplace-color-yellow-400"),
    X("betterplace-me-color-orange-500"),
    X("betterplace-color-red-700"),
    X("betterplace-color-red-900"),
    X("betterplace-color-purple-400"),
    X("betterplace-color-purple-700"),
    X("betterplace-color-gray-500"),
    X("betterplace-color-gray-700"),
    X("betterplace-color-gray-900")
  ].filter(Boolean);
  return t && i.push(`#${Ze}`), /* @__PURE__ */ c.jsx(
    Hr,
    {
      ...a,
      color: `#${n === "transparent" ? Ze : n}`,
      presetColors: i,
      onChange: e,
      hexInputLabel: r,
      label: o
    }
  );
}
const Ur = "_container_kj9ur_2", Yr = "_screen_kj9ur_8", Gr = "_particle_kj9ur_86", Vr = "_circle_kj9ur_111", Ce = {
  container: Ur,
  screen: Yr,
  particle: Gr,
  "x-axis": "_x-axis_kj9ur_1",
  "y-axis": "_y-axis_kj9ur_1",
  circle: Vr,
  "rotation-0": "_rotation-0_kj9ur_119",
  "rotation-1": "_rotation-1_kj9ur_125",
  "rotation-2": "_rotation-2_kj9ur_131",
  "rotation-3": "_rotation-3_kj9ur_137",
  "rotation-4": "_rotation-4_kj9ur_143",
  "rotation-5": "_rotation-5_kj9ur_149"
};
function rt(e, t, n, r, o) {
  return (e - t) * (o - r) / (n - t) + r;
}
function un(e, t) {
  const n = e + t;
  return n > 360 ? n - 360 : n;
}
function dn() {
  return Math.random() > 0.5;
}
const fn = [0, 0, 1], Be = [
  // dual axis rotations (a bit more realistic)
  [1, 1, 0],
  [1, 0, 1],
  [0, 1, 1],
  // single axis rotations (a bit dumber)
  [1, 0, 0],
  [0, 1, 0],
  fn
];
function Wr([e, t, n]) {
  const [r, o, a] = fn;
  return r === e && o === t && a === n;
}
function Xr(e) {
  return !!Be[e] && !Wr(Be[e]) && dn();
}
function fe(e, t = 4) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
function pn(e) {
  return fe(e, 2).toString().replace(".", "-");
}
const Pt = 200, Jr = 800, Zr = 0.8, Qr = 0.33, Mt = 0.5, eo = Be.reduce((e, t, n) => ({
  ...e,
  [`--confetti-rotation-3d-${n}-50`]: t.map((r) => r / 2).join(),
  [`--confetti-rotation-3d-${n}-100`]: t.join()
}), {});
function to(e, t, n) {
  const o = {
    "--confetti-landing-point-y": typeof t == "string" ? t : `${t}px`
  };
  for (const a of e) {
    const i = `${fe(rt(Math.abs(un(a, 90) - 180), 0, 180, -n / 2, n / 2), 2)}px`;
    o[`--confetti-degree-${pn(a)}-landing-point-x`] = i;
  }
  return o;
}
function no({ color: e, degree: t }, n, r, o, a) {
  const i = Math.round(Math.random() * (Jr - Pt) + Pt), s = n - Math.round(Math.random() * 1e3), u = Math.random() < Zr ? fe(Math.random() * Qr, 2) : 0, d = u * -1, m = u, p = fe(Math.abs(rt(Math.abs(un(t, 90) - 180), 0, 180, -1, 1)), 4), h = fe(Math.random() * Mt, 4), b = fe(Math.random() * r * (dn() ? 1 : -1), 4), x = Mt, y = fe(Math.max(rt(Math.abs(t - 180), 0, 180, r, -r), 0), 4);
  return {
    "--confetti-animation-duration": `${s}ms`,
    "--confetti-particle-width": `${a ? o : Math.round(Math.random() * 4) + o / 2}px`,
    "--confetti-particle-height": `${a ? o : Math.round(Math.random() * 2) + o}px`,
    "--confetti-particle-color": e,
    "--confetti-rotation-animation-duration": `${i}ms`,
    "--confetti-landing-point-x": `var(--confetti-degree-${pn(t)}-landing-point-x)`,
    "--confetti-x1": u,
    "--confetti-x2": d,
    "--confetti-x3": m,
    "--confetti-x4": p,
    "--confetti-y1": h,
    "--confetti-y2": b,
    "--confetti-y3": x,
    "--confetti-y4": y
  };
}
const ro = 0.5, oo = 12, ao = "120vh", co = 1e3, so = 100, io = 2200, lo = ["#FFC700", "#FF0000", "#2E3191", "#41BBC7"];
function uo(e, t) {
  const n = 360 / e;
  return Array.from(In(e)).map((r) => ({
    color: t[r % t.length],
    degree: n * r
  }));
}
function Wa({
  particleCount: e = so,
  duration: t = io,
  colors: n = lo,
  particleSize: r = oo,
  force: o = ro,
  height: a = ao,
  width: i = co,
  zIndex: s,
  onComplete: l,
  ...u
}) {
  const [d, m] = S(), p = H(() => uo(e, n), [e, n]), h = H(() => p.map((y) => y.degree), [p]), b = H(() => to(h, a, i), [h, i, a]), x = I(null);
  return C(() => {
    var T;
    const y = x.current;
    if (!y) return;
    let g = 0, w = 0;
    const v = (T = y.closest("dialog")) == null ? void 0 : T.firstElementChild;
    if (v) {
      const $ = v.getBoundingClientRect();
      g = $.top, w = $.left;
    }
    const { top: A, left: E } = y.getBoundingClientRect();
    m({ top: A - g, left: E - w });
  }, []), C(() => {
    if (typeof l != "function") return;
    const y = setTimeout(l, t);
    return () => clearTimeout(y);
  }, [t]), /* @__PURE__ */ c.jsx("div", { ref: x, className: Ce.container, ...u, children: d && Gt(
    /* @__PURE__ */ c.jsx(
      "div",
      {
        className: Ce.screen,
        style: { ...eo, ...b, ...s ? { zIndex: s } : null },
        children: /* @__PURE__ */ c.jsx("div", { style: { position: "absolute", top: d.top, left: d.left }, children: p.map((y, g) => {
          const w = Math.round(Math.random() * (Be.length - 1)), v = Xr(w), A = no(y, t, o, r, v);
          return /* @__PURE__ */ c.jsx(
            "div",
            {
              className: k(Ce.particle, Ce[`rotation-${w}`], {
                [Ce.circle]: v
              }),
              style: A,
              children: /* @__PURE__ */ c.jsx("div", {})
            },
            y.degree
          );
        }) })
      }
    ),
    // we target the inner modal div
    document.getElementById("bp-portal-target-inert") ?? document.body
  ) });
}
const fo = "_copyTextContainer_rj38r_2", po = "_copyTextInput_rj38r_7", Ot = {
  copyTextContainer: fo,
  copyTextInput: po
}, ue = { Idle: "idle", Success: "success", FadingOut: "fading-out", Error: "error" };
function Xa({
  textToCopy: e,
  showPreview: t = !1,
  previewLabel: n,
  previewHint: r,
  children: o,
  onTextCopied: a,
  onError: i,
  className: s,
  fadeOutDelay: l = 3e3,
  idleDelay: u = 200
}) {
  const [d, m] = S(ue.Idle), p = _(async () => {
    await wt(l), m(ue.FadingOut), await wt(u), m(ue.Idle);
  }, [l, u]);
  C(() => {
    d !== ue.Success && d !== ue.Error || p().then().catch(console.error);
  }, [p, d]);
  const h = _(() => {
    e && zn(e).then(() => {
      a == null || a(e), m(ue.Success);
    }).catch((x) => {
      m(ue.Error), i == null || i(x);
    });
  }, [e, a, i]), b = H(() => o(h, d), [o, h, d]);
  return t ? /* @__PURE__ */ c.jsxs(Te, { className: k(Ot.copyTextContainer, s), children: [
    /* @__PURE__ */ c.jsx(
      Ft,
      {
        className: Ot.copyTextInput,
        readOnly: !0,
        label: n,
        description: r,
        value: e
      }
    ),
    b
  ] }) : b;
}
const mo = "_card_scf48_1", ho = "_amountContainer_scf48_10", bo = "_ctaAmountContainer_scf48_24", go = "_heading_scf48_30", yo = "_timestamp_scf48_39", xo = "_commentContainer_scf48_44", wo = "_comment_scf48_44", vo = "_showMoreButton_scf48_62", _o = "_expanded_scf48_72", ko = "_ctaContainer_scf48_78", J = {
  card: mo,
  amountContainer: ho,
  ctaAmountContainer: bo,
  heading: go,
  timestamp: yo,
  commentContainer: xo,
  comment: wo,
  showMoreButton: vo,
  expanded: _o,
  ctaContainer: ko
}, Re = ee(function({
  onKeyDown: t,
  onKeyUp: n,
  onKeyDownCapture: r,
  onKeyUpCapture: o,
  onClick: a,
  ...i
}, s) {
  const { disabled: l } = i, u = l ? K : t, d = l ? K : n, m = l ? K : o, p = l ? K : a;
  return /* @__PURE__ */ c.jsx(
    vn,
    {
      ...i,
      onClick: p,
      onChange: u,
      onKeyUp: d,
      onKeyUpCapture: m,
      ref: s
    }
  );
});
function Co({ className: e }) {
  return /* @__PURE__ */ c.jsxs(ot, { className: k(J.card, e), children: [
    /* @__PURE__ */ c.jsx(Ne, { width: "6.25rem", height: "2.82rem" }),
    /* @__PURE__ */ c.jsxs(Z, { space: "200", children: [
      /* @__PURE__ */ c.jsx(Ne, { width: "5.7rem", height: "1.25rem" }),
      /* @__PURE__ */ c.jsx(Ne, { width: "5.7rem", height: "1.05rem" })
    ] })
  ] });
}
function jo({
  className: e,
  amount: t,
  ctaText: n,
  ctaLink: r
}) {
  return /* @__PURE__ */ c.jsxs(ot, { className: k(J.card, e), children: [
    /* @__PURE__ */ c.jsx("div", { className: k(J.amountContainer, J.ctaAmountContainer), children: t }),
    /* @__PURE__ */ c.jsx("div", { className: J.ctaContainer, children: /* @__PURE__ */ c.jsx(qt, { href: r, children: n }) })
  ] });
}
function To({
  comment: e,
  showMoreLabel: t,
  showLessLabel: n,
  maxPreviewLines: r = 2
}) {
  const [o, a] = S(!1), [i, s] = S(!1), l = o ? n : t, u = I(null);
  C(() => {
    const m = u.current;
    if (!m) {
      s(!1);
      return;
    }
    const p = parseFloat(getComputedStyle(m).lineHeight), h = Math.ceil(m.scrollHeight / p);
    s(h > r);
  }, [r, s]);
  const d = _(() => {
    a((m) => !m);
  }, []);
  return /* @__PURE__ */ c.jsxs("div", { className: J.commentContainer, children: [
    /* @__PURE__ */ c.jsx(
      "div",
      {
        ref: u,
        className: k(J.comment, { [J.expanded]: o }),
        style: { "--max-preview-lines": r },
        children: e
      }
    ),
    i && /* @__PURE__ */ c.jsx(
      Re,
      {
        kind: "plain",
        size: "small",
        iconName: o ? "chevronUp" : "chevronDown",
        iconPosition: "right",
        onClick: d,
        className: J.showMoreButton,
        children: l
      }
    )
  ] });
}
function No({
  amount: e,
  heading: t,
  timestamp: n,
  comment: r,
  showMoreLabel: o,
  showLessLabel: a,
  maxPreviewLines: i,
  className: s
}) {
  return /* @__PURE__ */ c.jsxs(ot, { className: k(J.card, s), children: [
    /* @__PURE__ */ c.jsx("div", { className: J.amountContainer, children: /* @__PURE__ */ c.jsx("div", { children: e }) }),
    /* @__PURE__ */ c.jsxs(Z, { space: "none", children: [
      /* @__PURE__ */ c.jsx("div", { className: J.heading, children: t }),
      /* @__PURE__ */ c.jsx("div", { className: J.timestamp, children: n }),
      r && /* @__PURE__ */ c.jsx(
        To,
        {
          comment: r,
          showMoreLabel: o,
          showLessLabel: a,
          maxPreviewLines: i
        }
      )
    ] })
  ] });
}
function Ja({
  variant: e = "default",
  amount: t,
  ctaText: n,
  ctaLink: r,
  className: o,
  ...a
}) {
  return e === "skeleton" ? /* @__PURE__ */ c.jsx(Co, { className: o }) : e === "cta" ? /* @__PURE__ */ c.jsx(jo, { amount: t, ctaText: n, ctaLink: r, className: o }) : /* @__PURE__ */ c.jsx(No, { amount: t, className: o, ...a });
}
const Za = ee(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: a } = r, i = a ? K : t, s = a ? K : n;
  return /* @__PURE__ */ c.jsx(_n, { ...r, onChange: i, onClick: s, ref: o });
}), Lo = "_accordion_tsidy_1", zo = "_accordionItem_tsidy_6", So = "_content_tsidy_11", Ao = "_wrapper_tsidy_15", Io = "_accordionSummary_tsidy_25", Po = "_accordionIcon_tsidy_41", Mo = "_open_tsidy_59", Oo = "_closing_tsidy_76", de = {
  accordion: Lo,
  accordionItem: zo,
  content: So,
  wrapper: Ao,
  accordionSummary: Io,
  accordionIcon: Po,
  open: Mo,
  closing: Oo
}, mn = Kt({
  activeKey: void 0,
  prevKey: void 0,
  onTransitionFinished: (e) => {
  },
  scrollOnOpen: !0
});
function Eo() {
  return Ut(mn);
}
function Do({
  label: e,
  id: t,
  className: n,
  children: r,
  onClick: o
}) {
  const { activeKey: a, onTransitionFinished: i, prevKey: s, scrollOnOpen: l } = Eo(), [u, d] = S(a === t || s === t), m = I(null), p = I(null), h = _(
    (x) => {
      x.preventDefault(), o(t);
    },
    [o, t]
  ), b = _(
    (x) => {
      x.propertyName === "opacity" && x.target === m.current && a === t && (i(t), l && window.requestAnimationFrame(() => {
        if (!p.current) return;
        const y = Se(p.current);
        if (!y) return;
        const { top: g } = p.current.getBoundingClientRect(), w = y === window ? 0 : y.offsetTop;
        y.scrollBy({ behavior: "smooth", top: g - w });
      }));
    },
    [a, t, i, l]
  );
  return C(() => {
    if (a === s) return;
    const x = setTimeout(() => d(a === t), 1);
    return () => clearTimeout(x);
  }, [t, a, s]), // eslint-disable-next-line jsx-a11y/role-supports-aria-props
  /* @__PURE__ */ c.jsxs(
    "details",
    {
      open: !0,
      id: t,
      "aria-expanded": a === t ? "true" : "false",
      className: k(de.accordionItem, { [de.open]: u }, n),
      ref: p,
      children: [
        /* @__PURE__ */ c.jsxs("summary", { onClick: h, className: de.accordionSummary, children: [
          e,
          /* @__PURE__ */ c.jsx(oe, { name: "chevronDown", className: de.accordionIcon, size: "400" })
        ] }),
        /* @__PURE__ */ c.jsx("div", { className: de.wrapper, onTransitionEnd: b, ref: m, children: /* @__PURE__ */ c.jsx("div", { className: de.content, inert: a === t ? !1 : "true", children: r }) })
      ]
    }
  );
}
function $o({
  defaultKey: e,
  children: t,
  activeKey: n,
  onTransitionFinished: r,
  className: o,
  space: a = "300",
  animationSpeedInMs: i = 500,
  scrollOnOpen: s = !0
}) {
  const [l, u] = S(void 0), [d, m] = S(n ?? e), p = _(
    (h) => {
      r == null || r(h, l), u(h);
    },
    [r, l]
  );
  return C(() => {
    typeof n == "string" && (m(n), u(d));
  }, [n]), /* @__PURE__ */ c.jsx(
    Z,
    {
      className: k(de.accordion, o),
      space: a,
      style: {
        "--animation-speed": `${i}ms`,
        "--space": `var(--betterplace-spacing-${a})`
      },
      children: /* @__PURE__ */ c.jsx(mn.Provider, { value: { activeKey: d, onTransitionFinished: p, prevKey: l, scrollOnOpen: s }, children: t })
    }
  );
}
const Bo = "_modal_xnbvu_1", Ro = "_modalInner_xnbvu_52", Fo = "_modalHeader_xnbvu_56", Ho = "_closeButton_xnbvu_71", qo = "_modalContent_xnbvu_77", Ko = "_modalActions_xnbvu_81", Uo = "_portalTarget_xnbvu_90", Yo = "_portalTargetInert_xnbvu_97", ae = {
  modal: Bo,
  modalInner: Ro,
  modalHeader: Fo,
  closeButton: Ho,
  modalContent: qo,
  modalActions: Ko,
  portalTarget: Uo,
  portalTargetInert: Yo
};
function Go(e) {
  e && (!("close" in e) || typeof e.close != "function" || e.close());
}
const Qa = ee(function({
  id: t,
  isOpen: n,
  onClose: r,
  onOpen: o,
  onCloseComplete: a,
  onOpenComplete: i,
  title: s,
  customActions: l,
  children: u,
  manualFocusRef: d,
  closeText: m,
  closeOnClickOutside: p = !0,
  hideHeader: h = !1,
  hideActions: b = !1,
  classNames: x = {}
}, y) {
  const [g, w] = at(y), v = I(null), [A, E] = S(!0), T = _(() => d || (v.current ? v : g), [d, g]), $ = Fe(), f = t || $, N = _(
    (z) => {
      var te;
      if (z.key === "Escape") return r(z);
      if (z.key !== "Tab") return;
      const j = (te = g.current) == null ? void 0 : te.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ), O = j == null ? void 0 : j[0], U = j == null ? void 0 : j[j.length - 1];
      if (z.shiftKey && document.activeElement === O) {
        z.preventDefault(), U == null || U.focus();
        return;
      }
      !z.shiftKey && document.activeElement === U && (z.preventDefault(), O == null || O.focus());
    },
    [g, r]
  ), D = _(() => {
    a == null || a(), E(!0);
  }, [a]), B = _(() => {
    var z;
    i == null || i(), E(!0), (z = g.current) == null || z.removeAttribute("inert");
  }, [g, i]);
  C(() => {
    var j;
    E(!1);
    const z = g.current;
    if (z) {
      if (n) {
        z.showModal();
        const O = T();
        (j = O == null ? void 0 : O.current) == null || j.focus(), z.removeEventListener("transitionend", D), z.addEventListener("keydown", N), z.addEventListener("transitionend", B), o == null || o();
      } else
        z.removeEventListener("keydown", N), z.removeEventListener("transitionend", B), z.addEventListener("transitionend", D), Go(z), z.setAttribute("inert", "");
      return () => {
        z == null || z.removeEventListener("keydown", N), z.removeEventListener("transitionend", D), z.removeEventListener("transitionend", B);
      };
    }
  }, [T, N, n, g, D, o, B]);
  const V = _(
    (z) => {
      const { current: j } = g;
      z.target === j && r(z);
    },
    [g, r]
  );
  return (
    // Disabled because HTML dialog brings keyboard interaction with it
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ c.jsxs(
      "dialog",
      {
        id: f,
        ref: w,
        className: k(ae.modal, x.modal),
        onCancel: r,
        onClick: p ? V : void 0,
        "aria-labelledby": `modal-title-${f}`,
        "aria-modal": "true",
        title: s,
        tabIndex: -1,
        children: [
          /* @__PURE__ */ c.jsxs(Z, { space: "400", className: k(ae.modalInner, x.modalInner), children: [
            !h && /* @__PURE__ */ c.jsxs("div", { className: k(ae.modalHeader, x.titleContainer), children: [
              /* @__PURE__ */ c.jsx(kn, { level: "h200", as: "h2", id: `modal-title-${f}`, children: s }),
              /* @__PURE__ */ c.jsx(
                Re,
                {
                  kind: "plain",
                  className: ae.closeButton,
                  onClick: r,
                  ref: v,
                  type: "button",
                  iconName: "x",
                  iconProps: { title: m, color: "fg-content-primary" }
                }
              )
            ] }),
            /* @__PURE__ */ c.jsx("div", { className: k(ae.modalContent, x.contentContainer), children: (n || !A) && u }),
            !b && /* @__PURE__ */ c.jsx("div", { className: k(ae.modalActions, x.actionsContainer), children: l || /* @__PURE__ */ c.jsx(qn, { onClick: r, type: "button", children: m }) })
          ] }),
          n && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx("div", { id: "bp-portal-target", className: ae.portalTarget, role: "alert" }),
            /* @__PURE__ */ c.jsx("div", { id: "bp-portal-target-inert", className: ae.portalTargetInert, role: "alert" })
          ] })
        ]
      }
    )
  );
}), Vo = "_progressbar_13lvs_1", Wo = {
  progressbar: Vo
};
function Xo(e, t, n, r, o) {
  const a = xt(n == null ? void 0 : n.toString()) || "", i = xt(r == null ? void 0 : r.toString()), [s, l] = S(0), u = I(0);
  C(() => {
    l(e - u.current);
    const x = setTimeout(
      () => {
        l(0), u.current = e;
      },
      Math.round(t * 0.75)
    );
    return () => clearTimeout(x);
  }, [t, e]);
  const d = i && i !== "transparent" ? yt(i) : o ? 0 : 1, m = yt(a) - d, p = m <= 0 ? gt : Qe, h = m <= 0 ? Qe : gt, b = (Math.abs(m) > 0.49 ? h : p)(a, 40);
  return { delta: s, deltaColor: b, color: a, backgroundColor: i };
}
const Jo = 5e3, Et = 100;
function ec({
  id: e,
  progressBackgroundColor: t,
  progressColor: n,
  intervalMs: r = Jo,
  darkMode: o,
  value: a,
  max: i = Et,
  min: s = 0,
  invisibleLabelText: l,
  valueText: u,
  progressPercentage: d
}) {
  const m = i || Et, p = d ?? a / m * 100, { delta: h, deltaColor: b, backgroundColor: x, color: y } = Xo(
    p,
    r,
    n,
    t,
    o
  );
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      id: e,
      role: "progressbar",
      "aria-valuemin": s,
      "aria-valuemax": m,
      "aria-valuenow": a,
      "aria-valuetext": u,
      "aria-label": l,
      className: k(Wo.progressbar, "progressbar"),
      style: {
        "--transition-duration": `${r}ms`,
        "--background-color": x,
        "--color": y,
        "--percent-delta": h / p,
        "--delta-color": b
      },
      children: /* @__PURE__ */ c.jsx("span", { style: { maxInlineSize: `${Math.round(p)}%` } })
    }
  );
}
const tc = ee(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: a } = r, i = a ? K : t, s = a ? K : n;
  return /* @__PURE__ */ c.jsx(Cn, { ...r, onChange: i, onClick: s, ref: o });
}), Zo = "_input_1bj67_1", Qo = "_growWrap_1bj67_2", Me = {
  input: Zo,
  growWrap: Qo,
  "input--error": "_input--error_1bj67_29"
}, nc = ee(function({
  label: t,
  name: n,
  description: r,
  error: o,
  warning: a,
  id: i,
  required: s,
  className: l,
  onChange: u,
  errorDisplay: d,
  rows: m = 1,
  fullWidth: p,
  ...h
}, b) {
  const x = I(null), y = [];
  return o && y.push(`${n}-error`), a && y.push(`${n}-warning`), r && y.push(`${n}-description`), /* @__PURE__ */ c.jsx(
    Ht,
    {
      label: t,
      name: n,
      description: r,
      error: o,
      warning: a,
      id: i || n,
      required: s,
      errorDisplay: d,
      fullWidth: p,
      /**
       * The following trick is used for the auto resizing textarea: https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
       * We need to make sure the same styles are applied to both the grow wrapper and the input
       */
      children: /* @__PURE__ */ c.jsx(
        "div",
        {
          className: k(Me.growWrap, l, {
            [Me.wrapError]: !!o,
            fullWidth: p && p !== "mobile-only",
            fullWidthOnMobile: p && p === "mobile-only"
          }),
          ref: x,
          children: /* @__PURE__ */ c.jsx(
            "textarea",
            {
              ...h,
              ref: b,
              id: i || n,
              name: n,
              "aria-describedby": y.length ? y.join(" ") : void 0,
              "aria-invalid": !!o,
              "aria-required": s,
              className: k(Me.input, l, {
                [Me["input--error"]]: !!o,
                fullWidth: p && p !== "mobile-only",
                fullWidthOnMobile: p && p === "mobile-only"
              }),
              rows: m,
              onChange: (g) => {
                var w;
                (w = x.current) == null || w.setAttribute("data-replicated-value", g.target.value), u && u(g);
              }
            }
          )
        }
      )
    }
  );
}), e0 = "_button_1ijcr_1", t0 = "_hiddenInput_1ijcr_58", Ve = {
  button: e0,
  hiddenInput: t0,
  "size-large": "_size-large_1ijcr_64",
  "size-default": "_size-default_1ijcr_69",
  "size-small": "_size-small_1ijcr_74"
}, rc = ee(function({
  id: t,
  children: n,
  value: r,
  name: o,
  onChange: a,
  onClick: i,
  className: s,
  type: l = "radio",
  size: u = "default",
  disabled_: d,
  disabled: m,
  fullWidth: p,
  ...h
}, b) {
  const x = k(Ve.button, Ve[`size-${u}`], s), y = Fe(), w = `${t || o || y}-${String(r)}`, v = m || d;
  return /* @__PURE__ */ c.jsxs(
    "label",
    {
      htmlFor: w,
      className: k(
        {
          fullWidth: p && p !== "mobile-only",
          fullWidthOnMobile: p && p === "mobile-only"
        },
        x
      ),
      children: [
        /* @__PURE__ */ c.jsx(
          "input",
          {
            ...h,
            ref: b,
            id: w,
            "aria-disabled": v,
            type: l,
            value: r,
            name: o,
            onClick: v ? K : i,
            onChange: v ? K : a,
            className: Ve.hiddenInput,
            disabled: d
          }
        ),
        n
      ]
    }
  );
}), oc = ee(function({ onChange: t, onClick: n, ...r }, o) {
  const { disabled: a } = r, i = a ? K : t, s = a ? K : n;
  return /* @__PURE__ */ c.jsx(jn, { ...r, onChange: i, onClick: s, ref: o });
}), n0 = "_tooltipContent_upgbl_1", r0 = "_spyElement_upgbl_12", o0 = "_opacityTransition_upgbl_18", a0 = "_opacityTransitionOpen_upgbl_23", We = {
  tooltipContent: n0,
  spyElement: r0,
  opacityTransition: o0,
  opacityTransitionOpen: a0
};
function ac(e) {
  return /* @__PURE__ */ c.jsx(
    nn,
    {
      ...e,
      Anchor: ct,
      triggerEvents: ["hover", "focus"],
      contentClassName: We.tooltipContent,
      contentWrapperClassName: We.opacityTransition,
      popupOpenWrapperClassName: We.opacityTransitionOpen,
      preferredPopupPosition: G.TOP
    }
  );
}
const c0 = "_tooltipTrigger_36bik_1", s0 = {
  tooltipTrigger: c0
}, cc = ({ type: e = "question", title: t = "More information", className: n }) => /* @__PURE__ */ c.jsx("button", { className: k(s0.tooltipTrigger, n), type: "button", children: /* @__PURE__ */ c.jsx(oe, { name: e, title: t }) });
function i0(e, t, n) {
  return {
    position: "absolute",
    inset: 0,
    transform: `translateY(${e * (t + n)}px)`,
    height: `${t}px`
  };
}
const Xe = {
  Up: "Up",
  Down: "Down",
  None: null
};
function sc(e) {
  const [t, n] = S(!1);
  return C(() => (n(!0), () => {
    n(!1);
  }), []), t ? /* @__PURE__ */ c.jsx(hn, { ...e }) : null;
}
function l0(e, t, n, r) {
  const o = e + t, a = n * o, i = r % o;
  return a + i;
}
function u0(e, t) {
  return e === t ? !1 : !e && t || !t && e ? !0 : Object.keys(t).some((n) => t[n] !== e[n]);
}
function d0(e) {
  const [t, n] = S(e);
  return C(() => {
    u0(t, e) && n(e);
  }, [e]), t;
}
const hn = ee(function({
  className: t,
  style: n,
  children: r,
  overscanRows: o,
  maxRows: a,
  rowHeight: i = 0,
  rows: s,
  onScroll: l,
  initialRow: u,
  gap: d = 0,
  reactiveProps: m
}, p) {
  const h = d0(m), [b, x] = at(p), y = o || s, g = I(/* @__PURE__ */ new Map()), [w, v] = S(i), A = I(null), E = I((u ?? 0) * w), [T, $] = S(0), f = I(0), N = I(Xe.None), D = a ?? T + (s + y) * 2 + 1, B = s * (w + d), V = (w + d) * D, { width: z } = On({ ref: b });
  ze(() => {
    var L, M;
    const P = (M = (L = b.current) == null ? void 0 : L.firstElementChild) == null ? void 0 : M.firstElementChild;
    P && v(P.clientHeight);
  }, [b, z, h]);
  const j = `${w}px`;
  function O(P) {
    var L;
    return (!g.current.has(P) || ((L = g.current.get(P)) == null ? void 0 : L.height) !== j) && g.current.set(P, i0(P, w, d)), g.current.get(P);
  }
  const U = _(
    (P) => {
      const L = Math.max(0, P - y), M = Math.min(
        D - 1,
        // don't render past the end of the list
        P + s + y
      );
      return [L, M, P];
    },
    [D, y, s]
  ), te = [], [he, ve] = U(T);
  for (let P = he; P <= ve; P++)
    te.push(/* @__PURE__ */ c.jsx(r, { index: P, style: O(P) }, P));
  const _e = _(
    (P) => {
      A.current !== null && clearTimeout(A.current), A.current = setTimeout(() => {
        l == null || l(P), A.current = null;
      }, 50);
    },
    [l]
  );
  C(() => {
    f.current = T;
  }, [T]), ze(() => {
    var M, Y, le;
    const P = ((M = b.current) == null ? void 0 : M.scrollTop) ?? 0, L = l0(w, d, T, P);
    (le = (Y = b.current) == null ? void 0 : Y.scrollTo) == null || le.call(Y, { left: 0, top: L, behavior: "instant" }), l == null || l(U(T));
  }, [w, d, D]);
  const be = _(
    (P) => {
      const L = E.current;
      E.current = P.currentTarget.scrollTop;
      const M = Math.floor(E.current / (w + d));
      N.current = L < E.current ? Xe.Down : Xe.Up, _e(U(M)), $(M);
    },
    [U, _e, w, d]
  );
  return C(() => {
    var P, L;
    u && ((L = (P = b.current) == null ? void 0 : P.scrollTo) == null || L.call(P, { left: 0, top: u * (w + d), behavior: "instant" }), l == null || l(U(u)));
  }, [U, u, l, w, d, b]), C(() => () => {
    A != null && A.current && clearTimeout(A.current);
  }, []), /* @__PURE__ */ c.jsx(
    "div",
    {
      className: t,
      style: {
        // allow to override the height
        height: B,
        ...n,
        overflowY: "auto",
        position: "relative",
        scrollBehavior: "smooth",
        willChange: "contents",
        maxHeight: B
      },
      ref: x,
      onScroll: be,
      children: /* @__PURE__ */ c.jsxs("div", { style: { position: "absolute", top: 0, left: 0, right: 0, height: V }, children: [
        /* @__PURE__ */ Yt(r, { ...h, index: -1, key: -1, style: { opacity: "0", pointerEvents: "none" } }),
        te
      ] })
    }
  );
}), ic = Ln(hn), f0 = "_contentContainer_1w2ql_1", p0 = "_outerContainer_1w2ql_17", m0 = "_bottomOnly_1w2ql_23", h0 = "_bright_1w2ql_28", b0 = "_dark_1w2ql_32", g0 = "_topOnly_1w2ql_36", ge = {
  contentContainer: f0,
  outerContainer: p0,
  bottomOnly: m0,
  bright: h0,
  dark: b0,
  topOnly: g0
};
function lc({ children: e, bright: t = !1, topOnly: n, bottomOnly: r, className: o, space: a = "none" }) {
  return /* @__PURE__ */ c.jsx(
    Z,
    {
      space: "none",
      className: k(ge.outerContainer, {
        [ge.bright]: t,
        [ge.dark]: !t,
        [ge.bottomOnly]: r,
        [ge.topOnly]: n
      }),
      style: {
        "--space": `var(--betterplace-spacing-${a})`
      },
      children: /* @__PURE__ */ c.jsx(Z, { space: "400", className: k(ge.contentContainer, o), children: e })
    }
  );
}
const y0 = "_footer_f7tu9_1", x0 = "_link_f7tu9_6", Dt = {
  footer: y0,
  link: x0
};
function Q(e) {
  return /* @__PURE__ */ c.jsx(qt, { ...e });
}
function Ke(e) {
  return /* @__PURE__ */ c.jsx("img", { ...e });
}
function se({
  Link: e,
  href: t,
  hidden: n,
  children: r,
  external: o,
  className: a,
  onClick: i,
  title: s,
  doNotOpenInNewTab: l
}) {
  return /* @__PURE__ */ c.jsx(
    e,
    {
      href: t,
      onClick: i,
      title: s,
      "aria-label": s,
      className: k(a, { "hide-link": n }),
      rel: o ? "noopener noreferrer" : void 0,
      target: l || !o ? void 0 : "_blank",
      children: r
    }
  );
}
function uc({ text: e, Link: t = Q }) {
  return /* @__PURE__ */ c.jsxs("footer", { className: k("bp-shared", Dt.footer), children: [
    e.providerInfo,
    e.links.map(({ className: n, ...r }, o) => /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx(se, { Link: t, ...r, className: k(Dt.link, n) }) }, o))
  ] });
}
const bn = "data:image/svg+xml,%3csvg%20enable-background='new%200%200%202406.6%20358.8'%20viewBox='0%200%202406.6%20358.8'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='m213.9%20290.7c9.7-10.4%2020.7-22.3%2035.5-38.4%2050.5-54.6%2059.8-111.8%2043.1-159-15.8-44.5-75.1-93.3-141.7-93.3-68.4.5-128.2%2046.6-143.4%2093.4-10.2%2031.5-20%2089.9%2045.4%20159.9l97.8%20105.5%2021-22.6s-68.8-74.5-93.8-101.5c-20.2-24.9-55.2-69.3-40.7-127.7%205.5-22.3%2045.3-76.4%20113.8-76.2%2068.4.2%20105.7%2056.7%20111.9%2073.4%2014.3%2038.7%206.3%2082.1-38.6%20130.2-16%2017.1-7.6%208.3-23.9%2025.7%200%200-66.2-71.8-83.2-90.4-12.6-13.8-14.6-36-.8-49.6%2013.6-13.3%2034.6-17.3%2051.5-1.1l19.9%2021.7c10.3%2010.7%2014.6%2010.6%2024.1.8%207.4-7.6%2024.5-26.5%2028.9-31.4-7.6-7.4-13.7-13.4-21.9-21.6-4.9%205.2-16%2017.3-18.7%2020.1-10.7-11.5-24.2-30.5-56.5-30.8-19.6%200-37%208.3-49%2020.2-16.4%2018-19.3%2033.3-19.6%2041.7-.6%2017.4%201.3%2031.7%2022.9%2055.3%2035.3%2038.2%2078.5%2084.7%2089%2095.9%2010.4%2011%2016.8%2010.8%2027-.2z'%20fill='%239ecb09'/%3e%3cpath%20d='m2084.9%20273.4c0%2010.7-8.6%2019.6-19.6%2019.6-10.7%200-19.3-8.9-19.3-19.6%200-10.5%208.6-19.3%2019.3-19.3%2011%200%2019.6%208.9%2019.6%2019.3z'/%3e%3cpath%20d='m2214.9%20235c0%2034.5-19.5%2057.7-52.2%2057.7-32.5%200-52.2-21.6-52.2-57.7%200-34.7%2019.5-57.7%2052.4-57.7%2032.4%200%2052%2021.5%2052%2057.7zm-74%200c0%2025.1%207.4%2036%2021.8%2036s21.8-11.1%2021.8-36c0-25.1-7.4-36-21.6-36-14.6%200-22%2011.1-22%2036z'/%3e%3cpath%20d='m2297.6%20179-4.9%2028.2c-3.3-.8-6-1.4-9.7-1.4-13.4%200-19.5%209.9-23.4%2027.3v59.5h-29.2v-112.1h25.3l2.7%2021.2c5.1-15.2%2015.6-24.3%2028.4-24.3%203.8%200%207.1.6%2010.8%201.6z'/%3e%3cpath%20d='m2406.6%20186.5c-8%203.1-18.3%204.1-31.4%204.1%2013.4%206%2020.1%2014.2%2020.1%2028%200%2021.2-17.1%2036.6-44.8%2036.6-4.7%200-8.8-.4-12.7-1.4-2.5%201.6-4.1%204.3-4.1%207.2%200%203.7%201.8%207.2%2012.5%207.2h16.6c24.7%200%2040.5%2013.2%2040.5%2031.2%200%2022-19.1%2035.4-55.5%2035.4-39.9%200-50.8-13-50.8-34.7h26.1c0%2010.3%204.5%2014.8%2025.3%2014.8%2020.1%200%2025.5-5.5%2025.5-13.4%200-7.4-5.6-11.9-17.1-11.9h-16c-22.8%200-32.3-9.9-32.3-21.4%200-7.8%204.9-15.4%2012.7-20.3-13.6-7.4-19.3-17.1-19.3-31%200-24%2019.1-39.5%2046.4-39.5%2025.1.6%2037.8-5.8%2051-13.2zm-75.4%2029.8c0%2012.5%207%2019.9%2018.1%2019.9%2011.7%200%2017.9-7%2017.9-20.3%200-13-6-19.1-18.1-19.1-11.1%200-17.9%207.6-17.9%2019.5z'/%3e%3cpath%20d='m1498.3%2030.6-50.1%2016.1v131.1h-14.4c-4.7-45.1-27.6-81.7-79.7-81.7-29.5%200-48.5%2013.1-59.7%2031.7h-.7v-27.2h-75.4c-29.9%200-37.7%2025.8-40%2043.7h-.7v-43.7h-44.4v128.6c-29.9%2018.9-58.9%2032.3-87.7%2032.4-31%20.1-52.6-21.3-54.9-52.2h120.9c0-67.2-23-112.2-79.4-112.4-59.7-.2-89.2%2045.9-89.2%20101.5%200%2019.6%203.6%2036.6%2010.4%2050.8-8.9%204.9-19.4%209.2-29.8%209.2-19-.1-23.5-15.3-23.5-31.7v-89.6h31.9l22-36.6h-53.8v-69l-50%2016.1v52.9h-52.8v-69l-50%2016.1-.1%2053.3h-19.8v35.9h19.9v89.2c-31.1%2020.2-61.4%2034.6-91.3%2034.7-31%20.1-52.6-20.4-54.9-51.4h120.3c0-67.2-22.4-113-78.9-113.2-52.5-.2-81.6%2035.4-87.9%2081.7h-12.7c-4.7-45.1-27.6-81.7-79.7-81.7-26.1%200-43.7%2010.8-57.5%2029.1h-.7v-94.5l-50%2015.7v246.4h48.5v-23.5h.7c14.6%2020.5%2037.7%2028%2059%2028%2051.9%200%2074.8-42.8%2079.6-87.7h12.4c6.3%2052.4%2042%2087.7%2099.4%2087.7%2025.4%200%2055.6-9.4%2099.4-32.1%208.9%2020.1%2027.6%2032%2055%2032%2014.8%200%2023.5-2.7%2033.3-7.3l-13.1-34.7c-2.6%201.7-5.6%202.9-9.5%203.1-19%20.9-21.5-15.2-21.5-31.6v-89.6h52.8v97.8c0%2038.1%2021.6%2062.3%2060.8%2062.3%2029.3%200%2039.5-7.1%2063.8-20.6%2016.9%2013.9%2040.1%2021.4%2068.7%2021.4%2023.6%200%2051.2-8%2090-27.3v22h50v-70.5c0-27.6%200-78.4%2040.7-78.4%208.7%200%2017.4%201.4%2022%203.9v210.8h50v-87.9h.7c17.5%2021.3%2035.1%2026.5%2056.4%2026.5%2055%200%2077.7-40.7%2081.2-87.9h14v24.7c0%2038.1%2021.6%2062.3%2060.8%2062.3%2023.9%200%2033.5-4.7%2041.4-8.3%2011.1%206%2024.3%209.2%2037.6%209.2%2022.8%200%2047.8-11.9%2059.3-33.2h.7c.4%206%20.4%2018.7%202.2%2028.7h44c-1.1-14.9-1.9-28.4-2.2-42.9-.3-10.8-.6-27.6-.7-40.8h12c6.3%2048.5%2037.6%2088.1%2093.6%2088.2%2020.7%200%2050.1-9.7%2074.1-27.2%2017.2%2018.2%2042.9%2028%2075.7%2028%2026.9%200%2051.1-9.7%2068-21.5v-40.5c-22.6%2019.1-39.1%2025.4-65.7%2025.4-31%200-52.6-21.3-54.9-52.2h120.9c0-67.2-23-112.2-79.4-112.4-59.7-.2-89.2%2045.9-89.2%20101.5%200%2015.4%202.2%2029.3%206.5%2041.4-12.2%209.7-25.2%2017.7-46.7%2018.6-35.1%201.5-51.9-27.2-51.9-62.7%200-36.2%2019.8-60.7%2050.8-60.8%2013.9%200%2017.6%201.9%2027.6%207.5l15.1-31.2c-19.3-9.6-32.7-15.1-52.9-15.1-52.1%200-83.8%2037-91.3%2082.1h-12.6c-.8-54.7-25.1-82.1-82.7-82.1-21.3%200-47.4%205.6-66.8%2014.6l1.5%2042.9c16.8-12.7%2038.1-20.9%2059.3-20.9%2029.5%200%2043.2%2014.4%2043.2%2045.4h-27.6c-20.9%200-45.4-2.1-64.4%207.2s-32.8%2026.1-32.8%2054.9c0%208.6%201.8%2016.3%205.1%2023-1.4.4-2.8.6-4.2.6-19%200-23.5-21.6-23.5-38zm-855.6%20102c26.3%200%2036.9%2020.9%2038.3%2045.2h-80.1c2.1-25.8%2015.4-45.2%2041.8-45.2zm-194.5%20125.8c-33.2%200-44-35.1-44-62.3%200-26.9%2012.7-61.2%2044.8-61.2%2032.5%200%2041.4%2035.5%2041.4%2061.2%200%2026.5-9.4%2062.3-42.2%2062.3zm584.2-124.9c26.3%200%2036.9%2020.1%2038.3%2044.3h-80.1c2.1-25.8%2015.4-44.3%2041.8-44.3zm307.9%20124.9c-33.2%200-44-35.1-44-62.3%200-26.9%2012.7-61.2%2044.8-61.2%2032.5%200%2041.4%2035.5%2041.4%2061.2%200%2026.5-9.3%2062.3-42.2%2062.3zm295.2-14.9c-7.8%2010.5-19.8%2017.2-35.1%2017.2-17.9%200-31.7-7.1-31.7-23.5%200-28.1%2032.6-28%2055-28h21.6c-.7%2015.7-3.9%2026.3-9.8%2034.3zm300.6-110c26.3%200%2036.8%2020.1%2038.2%2044.3h-80.1c2.2-25.8%2015.6-44.3%2041.9-44.3z'/%3e%3c/svg%3e", w0 = "_header_zzlnp_1", v0 = "_headerClaim_zzlnp_11", _0 = "_inner_zzlnp_35", k0 = "_headerLogo_zzlnp_54", C0 = "_headerLogoLink_zzlnp_59", j0 = "_imageContainer_zzlnp_65", T0 = "_logoDesktop_zzlnp_70", N0 = "_claimHidden_zzlnp_109", ce = {
  header: w0,
  headerClaim: v0,
  inner: _0,
  headerLogo: k0,
  headerLogoLink: C0,
  imageContainer: j0,
  logoDesktop: T0,
  claimHidden: N0
}, $t = 175;
function L0({
  Link: e = Q,
  Image: t = Ke,
  text: n,
  children: r,
  className: o,
  hideClaim: a
}) {
  return /* @__PURE__ */ c.jsx(
    "header",
    {
      style: { "--logo-size": `${$t}px` },
      className: k(ce.header, "bp-shared", { [ce.claimHidden]: a }, o),
      children: /* @__PURE__ */ c.jsxs("div", { className: ce.inner, children: [
        /* @__PURE__ */ c.jsx("div", { className: ce.headerLogo, children: /* @__PURE__ */ c.jsx(e, { href: n.homePageUrl, className: ce.headerLogoLink, children: /* @__PURE__ */ c.jsx("div", { className: ce.imageContainer, children: /* @__PURE__ */ c.jsx(t, { src: bn, alt: n.logoAlt, width: $t, className: ce.logoDesktop }) }) }) }),
        /* @__PURE__ */ c.jsx("div", { className: ce.headerClaim, "data-axe-expect": "color-contrast", children: n.claim }),
        r
      ] })
    }
  );
}
const z0 = "data:image/svg+xml,%3csvg%20enable-background='new%200%200%20402.872%20109.449'%20height='109.449'%20viewBox='0%200%20402.872%20109.449'%20width='402.872'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3clinearGradient%20id='a'%20gradientUnits='userSpaceOnUse'%20x1='0'%20x2='161.0322'%20y1='57.5601'%20y2='57.5601'%3e%3cstop%20offset='0'%20stop-color='%230d0d0d'/%3e%3cstop%20offset='.2418'%20stop-color='%23ababab'/%3e%3cstop%20offset='.5'%20stop-color='%23f2f2f2'/%3e%3cstop%20offset='.7473'%20stop-color='%23ababab'/%3e%3cstop%20offset='1'%20stop-color='%230d0d0d'/%3e%3c/linearGradient%3e%3clinearGradient%20id='b'%20gradientUnits='userSpaceOnUse'%20x1='0'%20x2='161.0322'%20y1='40.2637'%20y2='40.2637'%3e%3cstop%20offset='0'%20stop-color='%230d0d0d'/%3e%3cstop%20offset='.2418'%20stop-color='%23737373'/%3e%3cstop%20offset='.5'%20stop-color='%23ccc'/%3e%3cstop%20offset='.7473'%20stop-color='%23737373'/%3e%3cstop%20offset='1'%20stop-color='%230d0d0d'/%3e%3c/linearGradient%3e%3cpath%20d='m80.516%20109.449-80.516-39.637%2080.516-29.547%2080.516%2029.547z'/%3e%3cpath%20d='m80.516%2092.152-80.516-39.637%2080.516-29.547%2080.516%2029.547z'%20fill='url(%23a)'%20opacity='.5'/%3e%3cpath%20d='m80.516%2074.856-80.516-39.636%2080.516-29.549%2080.516%2029.549z'%20fill='url(%23b)'%20opacity='.35'/%3e%3cg%20fill='%234d4d4d'%3e%3cpath%20d='m205.851%2013.923h2.25v18.918h-2.25z'/%3e%3cpath%20d='m213.265%2019.342h2.223v2.02c1.176-1.15%202.863-2.301%205.063-2.301%202.58%200%203.987%201.483%203.987%204.04v9.74h-2.199v-9.255c0-1.789-.767-2.632-2.479-2.632-1.608%200-2.966.844-4.372%202.173v9.714h-2.223z'/%3e%3cpath%20d='m229.037%2014.307h2.302v2.146h-2.302zm.052%205.035h2.197v13.499h-2.197z'/%3e%3cpath%20d='m236.937%2029.568v-8.411h-2.352v-1.815h2.352v-4.806h2.198v4.806h3.503v1.815h-3.503v7.925c0%201.431.46%202.146%202.096%202.146.486%200%201.023-.077%201.382-.179v1.815c-.385.077-1.228.154-1.919.154-2.837.001-3.757-1.099-3.757-3.45z'/%3e%3cpath%20d='m246.344%2014.307h2.302v2.146h-2.302zm.052%205.035h2.198v13.499h-2.198z'/%3e%3cpath%20d='m252.454%2029.645c0-2.736%202.327-4.679%209.024-5.623v-.615c0-1.687-.896-2.504-2.558-2.504-2.045%200-3.553.895-4.883%202.045l-1.149-1.38c1.56-1.431%203.579-2.505%206.263-2.505%203.221%200%204.499%201.688%204.499%204.499v5.957c0%201.636.102%202.633.384%203.324h-2.249c-.179-.563-.307-1.1-.307-1.867-1.51%201.407-3.197%202.07-5.216%202.07-2.324-.003-3.808-1.228-3.808-3.401zm9.025-.307v-3.784c-5.139.819-6.852%202.071-6.852%203.758%200%201.303.869%201.995%202.274%201.995%201.79%200%203.324-.743%204.578-1.969z'/%3e%3cpath%20d='m269.02%2029.568v-8.411h-2.352v-1.815h2.352v-4.806h2.198v4.806h3.502v1.815h-3.502v7.925c0%201.431.46%202.146%202.096%202.146.486%200%201.023-.077%201.382-.179v1.815c-.385.077-1.228.154-1.919.154-2.837.001-3.757-1.099-3.757-3.45z'/%3e%3cpath%20d='m278.427%2014.307h2.3v2.146h-2.3zm.05%205.035h2.199v13.499h-2.199z'/%3e%3cpath%20d='m283.923%2019.342h2.352l3.783%2010.941h.052l3.731-10.941h2.2l-4.935%2013.549h-2.225z'/%3e%3cpath%20d='m297.754%2026.091c0-4.908%203.272-7.03%206.108-7.03%203.194%200%205.625%202.25%205.625%207.133v.46h-9.536c.078%203.041%201.841%204.677%204.065%204.677%201.943%200%203.04-.792%204.064-2.198l1.279%201.125c-1.254%201.789-2.968%202.864-5.498%202.864-3.193%200-6.107-2.327-6.107-7.031zm9.638-1.15c-.181-2.403-1.33-4.04-3.555-4.04-1.814%200-3.527%201.252-3.835%204.04z'/%3e%3c/g%3e%3cpath%20d='m210.095%2044.377h-6.008v-2.072h14.289v2.072h-6.031v16.845h-2.25z'/%3e%3cpath%20d='m218.403%2047.725h2.199v2.506h.05c.998-1.561%202.582-2.787%205.216-2.787h.28l-.154%202.045c-.074-.025-.562-.025-.639-.025-2.147%200-3.757%201.124-4.753%203.042v8.717h-2.199z'/%3e%3cpath%20d='m227.963%2058.027c0-2.734%202.327-4.676%209.024-5.626v-.611c0-1.688-.895-2.506-2.556-2.506-2.046%200-3.553.896-4.883%202.045l-1.15-1.38c1.559-1.431%203.579-2.505%206.262-2.505%203.222%200%204.499%201.687%204.499%204.5v5.956c0%201.636.103%202.633.384%203.322h-2.25c-.179-.564-.306-1.1-.306-1.865-1.509%201.404-3.195%202.07-5.215%202.07-2.325%200-3.809-1.227-3.809-3.4zm9.024-.306v-3.783c-5.139.817-6.852%202.07-6.852%203.756%200%201.305.87%201.994%202.275%201.994%201.79%200%203.324-.741%204.577-1.967z'/%3e%3cpath%20d='m243.558%2047.725h2.225v2.021c1.176-1.151%202.861-2.302%205.062-2.302%202.582%200%203.987%201.482%203.987%204.039v9.739h-2.198v-9.254c0-1.789-.768-2.633-2.48-2.633-1.608%200-2.966.844-4.37%202.172v9.715h-2.225v-13.497z'/%3e%3cpath%20d='m258.256%2059.177%201.33-1.329c1.021%201.099%202.377%201.866%204.219%201.866%202.096%200%203.246-.743%203.246-2.123%200-1.354-1.176-1.864-3.476-2.401-2.863-.69-4.832-1.456-4.832-4.066%200-2.044%201.79-3.68%204.729-3.68%202.379%200%203.911.767%205.165%201.942l-1.151%201.457c-1.023-.944-2.403-1.61-3.91-1.61-1.969%200-2.736.869-2.736%201.814%200%201.252%201.074%201.715%203.195%202.199%203.042.741%205.14%201.484%205.14%204.269%200%202.583-2.329%203.962-5.395%203.962-2.429%200-4.425-.97-5.524-2.3z'/%3e%3cpath%20d='m272.955%2047.725h2.199v1.866c1.022-1.124%202.43-2.147%204.448-2.147%203.093%200%205.496%202.302%205.496%207.005%200%204.702-2.429%206.979-5.727%206.979-1.662%200-3.068-.741-4.218-1.943v6.852h-2.199v-18.612zm9.944%206.749c0-3.452-1.637-5.139-3.81-5.139-1.559%200-2.811.844-3.936%202.071v6.185c1.177%201.33%202.479%202.047%203.911%202.047%202.353%200%203.835-1.586%203.835-5.164z'/%3e%3cpath%20d='m287.836%2058.027c0-2.734%202.326-4.676%209.023-5.626v-.611c0-1.688-.897-2.506-2.558-2.506-2.044%200-3.553.896-4.883%202.045l-1.148-1.38c1.559-1.431%203.577-2.505%206.263-2.505%203.219%200%204.499%201.687%204.499%204.5v5.956c0%201.636.102%202.633.383%203.322h-2.25c-.179-.564-.306-1.1-.306-1.865-1.509%201.404-3.197%202.07-5.216%202.07-2.327%200-3.807-1.227-3.807-3.4zm9.023-.306v-3.783c-5.139.817-6.853%202.07-6.853%203.756%200%201.305.869%201.994%202.275%201.994%201.791%200%203.325-.741%204.578-1.967z'/%3e%3cpath%20d='m303.429%2047.725h2.198v2.506h.052c.995-1.561%202.581-2.787%205.214-2.787h.28l-.151%202.045c-.077-.025-.562-.025-.642-.025-2.146%200-3.756%201.124-4.753%203.042v8.717h-2.198z'/%3e%3cpath%20d='m312.836%2054.474c0-4.909%203.271-7.03%206.11-7.03%203.194%200%205.623%202.25%205.623%207.131v.461h-9.535c.076%203.042%201.841%204.679%204.064%204.679%201.943%200%203.042-.793%204.063-2.199l1.278%201.126c-1.251%201.79-2.963%202.861-5.494%202.861-3.195-.001-6.109-2.326-6.109-7.029zm9.638-1.15c-.179-2.403-1.33-4.04-3.554-4.04-1.815%200-3.528%201.253-3.835%204.04z'/%3e%3cpath%20d='m328.354%2047.725h2.224v2.021c1.176-1.151%202.862-2.302%205.061-2.302%202.584%200%203.988%201.482%203.988%204.039v9.739h-2.197v-9.254c0-1.789-.768-2.633-2.48-2.633-1.611%200-2.966.844-4.371%202.172v9.715h-2.224v-13.497z'/%3e%3cpath%20d='m344.995%2057.95v-8.41h-2.352v-1.814h2.352v-4.806h2.198v4.805h3.502v1.814h-3.502v7.926c0%201.432.46%202.147%202.096%202.147.485%200%201.021-.077%201.382-.179v1.814c-.385.077-1.228.152-1.919.152-2.837.002-3.757-1.098-3.757-3.449z'/%3e%3cpath%20d='m353.355%2054.474c0-4.909%203.271-7.03%206.108-7.03%203.196%200%205.623%202.25%205.623%207.131v.461h-9.533c.076%203.042%201.839%204.679%204.064%204.679%201.943%200%203.042-.793%204.063-2.199l1.278%201.126c-1.253%201.79-2.965%202.861-5.496%202.861-3.192-.001-6.107-2.326-6.107-7.029zm9.636-1.15c-.179-2.403-1.33-4.04-3.552-4.04-1.815%200-3.528%201.253-3.834%204.04z'/%3e%3cpath%20d='m204.292%2088.02%2011.067-15.44h-10.352v-1.892h13.113v1.636l-10.992%2015.413h10.992v1.867h-13.829v-1.584z'/%3e%3cpath%20d='m222.059%2071.071h2.3v2.148h-2.3zm.05%205.036h2.199v13.497h-2.199z'/%3e%3cpath%20d='m227.555%2076.107h2.353l3.783%2010.94h.051l3.733-10.94h2.197l-4.935%2013.548h-2.223z'/%3e%3cpath%20d='m242.893%2071.071h2.301v2.148h-2.301zm.052%205.036h2.198v13.497h-2.198z'/%3e%3cpath%20d='m249.975%2070.688h2.198v18.916h-2.198z'/%3e%3cpath%20d='m255.343%2091.445c0-1.38.944-2.403%202.453-2.992-.766-.358-1.15-.918-1.15-1.713%200-.868.716-1.609%201.688-2.171-1.304-.845-2.071-2.199-2.071-3.887%200-2.837%202.274-4.855%205.496-4.855%201.661%200%203.041.562%203.987%201.404.818-.611%202.096-1.124%203.197-1.252v1.943c-.741%200-1.639.128-2.43.435.436.614.691%201.405.691%202.325%200%202.915-2.302%204.807-5.446%204.807-.791%200-1.456-.129-2.147-.333-.562.257-.945.587-.945%201.048%200%20.563.434.819%201.865.948l2.762.229c3.425.229%205.163%201.327%205.163%203.502%200%202.556-2.683%203.91-6.595%203.91-4.549%200-6.518-1.303-6.518-3.348zm11.095-.358c0-1.203-.896-1.737-3.733-1.941l-2.556-.181c-.256-.025-.513-.053-.767-.076-1.305.461-1.995%201.303-1.995%202.224%200%201.354%201.406%202.021%204.757%202.021%202.683-.001%204.294-.821%204.294-2.047zm-1.281-10.353c0-1.969-1.226-3.194-3.398-3.194-2.096%200-3.4%201.252-3.4%203.194%200%201.941%201.355%203.145%203.427%203.145%202.068-.001%203.371-1.204%203.371-3.145z'/%3e%3cpath%20d='m270.912%2082.857c0-4.909%203.271-7.03%206.108-7.03%203.195%200%205.624%202.249%205.624%207.132v.46h-9.535c.076%203.04%201.84%204.676%204.064%204.676%201.943%200%203.042-.791%204.064-2.197l1.28%201.126c-1.256%201.788-2.968%202.861-5.498%202.861-3.194-.001-6.107-2.327-6.107-7.028zm9.638-1.151c-.181-2.403-1.33-4.04-3.555-4.04-1.815%200-3.527%201.254-3.834%204.04z'/%3e%3cpath%20d='m285.202%2087.558%201.328-1.328c1.023%201.099%202.377%201.864%204.219%201.864%202.096%200%203.246-.738%203.246-2.118%200-1.356-1.176-1.869-3.476-2.406-2.863-.688-4.832-1.456-4.832-4.062%200-2.047%201.79-3.682%204.729-3.682%202.379%200%203.913.766%205.163%201.941l-1.148%201.457c-1.024-.945-2.404-1.609-3.911-1.609-1.969%200-2.736.868-2.736%201.814%200%201.252%201.074%201.713%203.197%202.198%203.04.741%205.136%201.483%205.136%204.269%200%202.582-2.324%203.962-5.393%203.962-2.429.001-4.422-.969-5.522-2.3z'/%3e%3cpath%20d='m298.905%2082.857c0-4.909%203.27-7.03%206.107-7.03%203.194%200%205.624%202.249%205.624%207.132v.46h-9.536c.079%203.04%201.842%204.676%204.066%204.676%201.944%200%203.04-.791%204.064-2.197l1.277%201.126c-1.252%201.788-2.965%202.861-5.496%202.861-3.193-.001-6.106-2.327-6.106-7.028zm9.635-1.151c-.179-2.403-1.329-4.04-3.552-4.04-1.814%200-3.528%201.254-3.834%204.04z'/%3e%3cpath%20d='m314.574%2070.688h2.199v18.916h-2.199z'/%3e%3cpath%20d='m321.604%2070.688h2.2v18.916h-2.2z'/%3e%3cpath%20d='m327.51%2087.558%201.328-1.328c1.023%201.099%202.378%201.864%204.221%201.864%202.095%200%203.244-.738%203.244-2.118%200-1.356-1.176-1.869-3.476-2.406-2.863-.688-4.832-1.456-4.832-4.062%200-2.047%201.789-3.682%204.73-3.682%202.377%200%203.91.766%205.163%201.941l-1.151%201.457c-1.021-.945-2.401-1.609-3.91-1.609-1.969%200-2.734.868-2.734%201.814%200%201.252%201.074%201.713%203.194%202.198%203.043.741%205.139%201.483%205.139%204.269%200%202.582-2.327%203.962-5.395%203.962-2.428.001-4.423-.969-5.521-2.3z'/%3e%3cpath%20d='m341.212%2082.857c0-4.935%203.17-7.03%206.186-7.03%203.043%200%204.474%201.789%205.292%203.783l-1.864.766c-.666-1.738-1.715-2.685-3.479-2.685-1.943%200-3.912%201.354-3.912%205.166%200%203.321%201.586%205.188%203.863%205.188%201.713%200%202.758-.741%203.627-2.71l1.817.717c-1.05%202.249-2.608%203.833-5.523%203.833-3.117-.001-6.007-2.402-6.007-7.028z'/%3e%3cpath%20d='m356.321%2070.688h2.223v7.438c1.176-1.149%202.864-2.3%205.062-2.3%202.582%200%203.987%201.481%203.987%204.037v9.74h-2.195v-9.253c0-1.79-.771-2.633-2.481-2.633-1.61%200-2.966.843-4.372%202.173v9.713h-2.223v-18.915z'/%3e%3cpath%20d='m371.172%2086.41c0-2.735%202.327-4.679%209.024-5.624v-.614c0-1.688-.893-2.506-2.557-2.506-2.043%200-3.552.896-4.882%202.047l-1.148-1.38c1.557-1.433%203.578-2.506%206.262-2.506%203.22%200%204.497%201.688%204.497%204.499v5.954c0%201.638.104%202.633.386%203.324h-2.25c-.179-.562-.308-1.098-.308-1.867-1.507%201.409-3.195%202.072-5.215%202.072-2.325%200-3.809-1.227-3.809-3.399zm9.024-.309v-3.781c-5.137.817-6.85%202.068-6.85%203.758%200%201.304.868%201.994%202.275%201.994%201.79%200%203.322-.743%204.575-1.971z'/%3e%3cpath%20d='m387.815%2077.922h-2.352v-1.815h2.352v-1.814c0-2.274%201.2-3.656%204.064-3.656.385%200%201.049.077%201.252.077v1.789c-.203-.052-.64-.076-.946-.076-1.226%200-2.173.435-2.173%201.891v1.79h2.966v1.815h-2.966v11.682h-2.197z'/%3e%3cpath%20d='m397.172%2086.332v-8.409h-2.352v-1.815h2.352v-4.805h2.198v4.805h3.502v1.815h-3.502v7.925c0%201.43.459%202.146%202.095%202.146.487%200%201.024-.075%201.382-.179v1.816c-.385.077-1.228.152-1.918.152-2.837%200-3.757-1.1-3.757-3.451z'/%3e%3cpath%20d='m183.244%200h2.379v105.309h-2.379z'%20fill='%234d4d4d'/%3e%3c/svg%3e", S0 = "_taxReceiptHint_cb2m5_1", A0 = "_content_cb2m5_24", Bt = {
  taxReceiptHint: S0,
  content: A0
};
function I0() {
  const e = /* @__PURE__ */ new Date();
  return e.getMonth() > 8 || e.getMonth() < 1;
}
function P0() {
  const e = /* @__PURE__ */ new Date();
  let t = e.getFullYear();
  return e.getMonth() < 9 && (t -= 1), t;
}
function M0({
  children: e,
  href: t,
  label: n,
  Link: r = Q
}) {
  const [o, a] = S(!1), [i, s] = S(0);
  return C(() => {
    a(I0()), s(P0());
  }, []), o ? /* @__PURE__ */ c.jsx(Z, { space: "none", className: Bt.taxReceiptHint, children: /* @__PURE__ */ c.jsx("div", { className: Bt.content, children: /* @__PURE__ */ c.jsxs("p", { children: [
    e.replace("0000", i.toString()).replace("0001", (i + 1).toString()),
    " ",
    /* @__PURE__ */ c.jsx(se, { Link: r, href: t, className: "bp-text-link-secondary", children: n })
  ] }) }) }) : null;
}
const O0 = "_footer_snrga_1", E0 = "_grid_snrga_14", D0 = "_item_snrga_18", $0 = "_mobileOnly_snrga_26", B0 = "_wideOnly_snrga_34", R0 = "_accordionContent_snrga_42", F0 = "_accordionLabel_snrga_46", H0 = "_footerLink_snrga_50", q0 = "_cookieSettingsLink_snrga_56", K0 = "_transparentCivilSocietyLink_snrga_60", U0 = "_logo_snrga_68", Y0 = "_organizationInfo_snrga_77", G0 = "_organizationInfoDetails_snrga_85", V0 = "_accessibilityStatement_snrga_90", W0 = "_accessibilityIcon_snrga_93", X0 = "_localeSwitchLink_snrga_100", J0 = "_socialLink_snrga_104", Z0 = "_socialLinks_snrga_113", Q0 = "_footerContent_snrga_120", ea = "_textContent_snrga_133", F = {
  footer: O0,
  grid: E0,
  item: D0,
  mobileOnly: $0,
  wideOnly: B0,
  accordionContent: R0,
  accordionLabel: F0,
  footerLink: H0,
  cookieSettingsLink: q0,
  transparentCivilSocietyLink: K0,
  logo: U0,
  organizationInfo: Y0,
  organizationInfoDetails: G0,
  accessibilityStatement: V0,
  accessibilityIcon: W0,
  localeSwitchLink: X0,
  socialLink: J0,
  socialLinks: Z0,
  footerContent: Q0,
  textContent: ea
};
function ta() {
  const e = window.location.hostname;
  if (!e) return "";
  const t = e.split(".");
  return t.length <= 2 ? e : t.slice(1).join(".");
}
const na = () => {
  const e = ta(), t = new Date(2099, 1, 1).getTime();
  document.cookie = `betterplace-tracking-accepted=edit; path=/; max-age=${t}; domain=.${e}`;
};
function ra(e) {
  if (!e.length) return [];
  const t = e.length > 1 ? e.sort(({ column: r }, { column: o }) => r - o) : e;
  let n = 0;
  return t.map((r) => {
    n = r.column ?? n;
    const o = {
      ...r,
      column: r.column ?? n
    };
    return n++, o;
  });
}
function oa(e) {
  const t = e.reduce(
    (n, r) => (n[r.column] = [...n[r.column] ?? [], r], n),
    {}
  );
  return Object.values(t);
}
function dt({ ...e }) {
  return /* @__PURE__ */ c.jsx(
    se,
    {
      ...e,
      doNotOpenInNewTab: !0,
      className: k(F.footerLink, "bp-text-link-secondary", "bp-text-link-small", e.className)
    }
  );
}
function gn({
  cookieSettingsLink: e,
  Link: t = Q,
  section: n
}) {
  return n.title !== e.section ? null : /* @__PURE__ */ c.jsx(dt, { Link: t, onClick: na, className: F.cookieSettingsLink, children: e.label }, "cookie");
}
function aa({
  children: e,
  Link: t = Q,
  links: n,
  mobile: r
}) {
  return r || /* @__PURE__ */ c.jsxs(Z, { space: "200", className: F.accordionContent, children: [
    n.map((o, a) => /* @__PURE__ */ c.jsx(dt, { Link: t, ...o }, a)),
    e
  ] });
}
function ca({
  links: e,
  Link: t = Q,
  desktop: n,
  children: r
}) {
  return n || /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    e.map((o, a) => /* @__PURE__ */ c.jsx(dt, { Link: t, ...o }, a)),
    r
  ] });
}
function sa({ text: e, Link: t = Q }) {
  const n = oa(ra(e.sections));
  return /* @__PURE__ */ c.jsx("nav", { className: F.wideOnly, children: /* @__PURE__ */ c.jsx(Te, { className: F.grid, flex: !0, space: "300", justify: "space-between", wrap: !0, children: n.map((r, o) => /* @__PURE__ */ c.jsx(Z, { className: F.item, space: "300", children: r.map((a) => /* @__PURE__ */ c.jsxs(Z, { children: [
    /* @__PURE__ */ c.jsx("p", { children: /* @__PURE__ */ c.jsx("strong", { children: a.title }) }, "title"),
    /* @__PURE__ */ c.jsx(ca, { links: a.links, desktop: a.desktop, Link: t, children: /* @__PURE__ */ c.jsx(gn, { cookieSettingsLink: e.cookieSettingsLink, section: a }, "cookie") })
  ] }, a.title)) }, o)) }) });
}
function ia({ text: e, Link: t = Q }) {
  const n = "", [r, o] = S(n);
  return /* @__PURE__ */ c.jsx("nav", { className: F.mobileOnly, children: /* @__PURE__ */ c.jsx(
    $o,
    {
      defaultKey: n,
      activeKey: r,
      scrollOnOpen: !1,
      space: "none",
      animationSpeedInMs: 300,
      children: e.sections.map((a) => /* @__PURE__ */ c.jsx(
        Do,
        {
          id: a.title,
          onClick: (i) => o((s) => i === s ? "" : i),
          label: /* @__PURE__ */ c.jsx("span", { className: F.accordionLabel, children: a.title }),
          children: /* @__PURE__ */ c.jsx(aa, { links: a.links, mobile: a.mobile, Link: t, children: /* @__PURE__ */ c.jsx(gn, { cookieSettingsLink: e.cookieSettingsLink, section: a }, "cookie") })
        },
        a.title
      ))
    }
  ) });
}
function dc({
  children: e,
  href: t,
  className: n,
  Link: r = Q
}) {
  const [o, a] = S(!0), [i, s] = S(!1);
  return C(() => {
    a(!t), s(!e);
  }, [t, e]), i ? null : /* @__PURE__ */ c.jsx(r, { disabled: o, href: t, className: k(F.localeSwitchLink, n), children: e });
}
function fc({ text: e, Link: t = Q, Image: n = Ke, localeSwitchLink: r }) {
  return /* @__PURE__ */ c.jsxs(Tn, { as: "footer", className: k("bp-shared", F.footer), centeredChildren: !0, children: [
    /* @__PURE__ */ c.jsx(M0, { label: e.taxReceiptHint.label, href: e.taxReceiptHint.href, Link: t, children: e.taxReceiptHint.children }),
    /* @__PURE__ */ c.jsxs(Z, { className: F.footerContent, flex: !0, children: [
      /* @__PURE__ */ c.jsx(sa, { text: e, Link: t }),
      /* @__PURE__ */ c.jsx(ia, { text: e, Link: t }),
      /* @__PURE__ */ c.jsx(n, { src: bn, alt: "betterplace", width: 190, className: F.logo }),
      /* @__PURE__ */ c.jsxs(Te, { alignment: "intrinsic", justify: "space-between", className: F.textContent, children: [
        /* @__PURE__ */ c.jsxs(Z, { className: F.organizationInfo, flex: !0, children: [
          /* @__PURE__ */ c.jsx("p", { children: /* @__PURE__ */ c.jsx("strong", { children: e.organizationInfo }) }),
          /* @__PURE__ */ c.jsx("p", { className: F.organizationInfoDetails, children: e.organizationInfoDetails })
        ] }),
        /* @__PURE__ */ c.jsxs(Z, { className: F.socialLinks, children: [
          /* @__PURE__ */ c.jsxs(Te, { justify: "space-between", align: "center", children: [
            /* @__PURE__ */ c.jsxs(Te, { space: "200", align: "center", children: [
              /* @__PURE__ */ c.jsxs(
                se,
                {
                  Link: t,
                  href: e.facebookLink.href,
                  title: e.facebookLink.label,
                  external: !0,
                  className: F.socialLink,
                  children: [
                    /* @__PURE__ */ c.jsx(oe, { name: "facebook", size: "400", "aria-hidden": "true" }),
                    /* @__PURE__ */ c.jsx("span", { className: "sr-only", children: e.facebookLink.label })
                  ]
                },
                "facebook"
              ),
              /* @__PURE__ */ c.jsxs(
                se,
                {
                  Link: t,
                  href: e.instagramLink.href,
                  title: e.instagramLink.label,
                  external: !0,
                  className: F.socialLink,
                  children: [
                    /* @__PURE__ */ c.jsx(oe, { name: "instagram", size: "400", "aria-hidden": "true" }),
                    /* @__PURE__ */ c.jsx("span", { className: "sr-only", children: e.instagramLink.label })
                  ]
                },
                "instagram"
              ),
              /* @__PURE__ */ c.jsxs(
                se,
                {
                  Link: t,
                  href: e.linkedinLink.href,
                  title: e.linkedinLink.label,
                  external: !0,
                  className: F.socialLink,
                  children: [
                    /* @__PURE__ */ c.jsx(oe, { name: "linkedin", size: "400", "aria-hidden": "true" }),
                    /* @__PURE__ */ c.jsx("span", { className: "sr-only", children: e.linkedinLink.label })
                  ]
                },
                "linkedin"
              )
            ] }),
            r
          ] }),
          /* @__PURE__ */ c.jsx(
            se,
            {
              Link: t,
              href: e.transparentCivilSocietyLink.href,
              className: F.transparentCivilSocietyLink,
              children: /* @__PURE__ */ c.jsx(n, { src: z0, alt: e.transparentCivilSocietyLink.label, width: 240 })
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ c.jsxs("div", { className: F.accessibilityStatement, children: [
        /* @__PURE__ */ c.jsx("a", { id: "a11y-statement", tabIndex: 0 }),
        /* @__PURE__ */ c.jsx(
          oe,
          {
            name: "accessibility",
            size: "300",
            "aria-hidden": "true",
            color: "fg-content-primary",
            className: F.accessibilityIcon
          }
        ),
        e.accessibilityStatement
      ] })
    ] })
  ] });
}
const la = "_form_1i53q_1", ua = "_inputContainer_1i53q_7", da = "_resetButton_1i53q_17", fa = "_open_1i53q_29", pa = "_input_1i53q_7", ma = "_searchButton_1i53q_56", ye = {
  form: la,
  inputContainer: ua,
  resetButton: da,
  open: fa,
  input: pa,
  searchButton: ma
};
function ha() {
  const [e, t] = S(!1);
  return C(() => {
    t(!0);
  }, []), e;
}
function ba({ text: { url: e, label: t, placeholder: n }, onShowSearch: r, onHideSearch: o, open: a, className: i }) {
  const s = I(null), l = I(null), u = ha();
  C(() => {
    !a || !l.current || l.current.focus();
  }, [a]);
  const d = _(
    (b) => {
      if (b.key === R.Enter || b.key === R.Space || b.key === R.Space) return o == null ? void 0 : o();
    },
    [o]
  ), m = _(() => {
    o == null || o();
  }, [o]), p = _(
    (b) => {
      b.key === R.Escape && (o == null || o());
    },
    [o]
  ), h = _(
    (b) => {
      var x;
      u && (a || (r == null || r(), b.preventDefault()), (x = l.current) != null && x.value || b.preventDefault());
    },
    [u, r, a]
  );
  return /* @__PURE__ */ c.jsxs("form", { action: e, method: "POST", ref: s, className: k(ye.form, i), children: [
    /* @__PURE__ */ c.jsxs("div", { className: k(ye.inputContainer, { [ye.open]: a }), children: [
      /* @__PURE__ */ c.jsx(
        "input",
        {
          onKeyUp: p,
          name: "query",
          placeholder: n,
          ref: l,
          id: "header-search-input",
          className: ye.input,
          tabIndex: a ? 0 : -1
        }
      ),
      /* @__PURE__ */ c.jsx(
        Re,
        {
          type: "reset",
          iconName: "x",
          onClick: m,
          onKeyUp: d,
          className: ye.resetButton,
          tabIndex: a ? 0 : -1,
          kind: "plain",
          "aria-label": "Reset"
        }
      )
    ] }),
    /* @__PURE__ */ c.jsx(
      Re,
      {
        size: "large",
        type: "submit",
        iconName: "search",
        disabled_: !u,
        onClick: h,
        className: ye.searchButton,
        title: t,
        children: /* @__PURE__ */ c.jsx("span", { className: "sr-only", children: t })
      }
    )
  ] });
}
const ga = "_navigationLink_nb818_1", ya = "_headerLink_nb818_19", Pe = {
  navigationLink: ga,
  headerLink: ya
}, xa = "_links_5flc4_1", wa = "_linkItem_5flc4_12", va = "_search_5flc4_35", _a = "_searchOpen_5flc4_46", je = {
  links: xa,
  linkItem: wa,
  search: va,
  searchOpen: _a
};
function pc({
  Link: e = Q,
  Image: t = Ke,
  children: n,
  text: { links: r, searchLabel: o, searchPlaceholder: a, searchUrl: i, ...s }
}) {
  const [l, u] = S(!1), d = _(() => u(!0), []), m = _(() => u(!1), []);
  return /* @__PURE__ */ c.jsxs(
    L0,
    {
      Link: e,
      Image: t,
      text: s,
      hideClaim: l,
      className: k({ [je.searchOpen]: l, [je.searchClosed]: !l }),
      children: [
        /* @__PURE__ */ c.jsx("ul", { className: je.links, children: r.map((p, h) => /* @__PURE__ */ c.jsx("li", { className: je.linkItem, children: /* @__PURE__ */ c.jsx(
          se,
          {
            Link: e,
            "data-axe-expect": "color-contrast",
            className: k(Pe.navigationLink, Pe.headerLink),
            ...p
          }
        ) }, h)) }),
        n,
        /* @__PURE__ */ c.jsx(
          ba,
          {
            open: l,
            text: { placeholder: a, label: o, url: i },
            onShowSearch: d,
            onHideSearch: m,
            className: je.search
          }
        )
      ]
    }
  );
}
const ka = "data:image/svg+xml,%3csvg%20height='66'%20viewBox='0%200%2066%2066'%20width='66'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='33'%20cy='33'%20fill='%239ecb09'%20r='33'/%3e%3cg%20fill='%23fff'%3e%3ccircle%20cx='33.22'%20cy='19.721'%20r='11.391'/%3e%3cpath%20d='m-173.769%20496.644a21.27%2021.27%200%200%200%20.108-2.145%2020.981%2020.981%200%200%200%20-12.08-19c-2.7-1.267-5.941-.19-9.122-.19-3.011%200-5.65-1.151-8.239-.009a20.984%2020.984%200%200%200%20-12.517%2019.2%2021.2%2021.2%200%200%200%20.136%202.4s8.568%207.864%2020.619%207.864c12.499.002%2021.095-8.12%2021.095-8.12z'%20transform='translate(227.86%20-441.616)'/%3e%3c/g%3e%3c/svg%3e", Ca = "_link_1whn0_1", ja = "_active_1whn0_18", Ta = "_image_1whn0_22", Na = "_login_1whn0_38", La = "_label_1whn0_54", za = "_trigger_1whn0_72", Sa = "_caret_1whn0_104", Aa = "_loginLink_1whn0_115", Ia = "_dropdownMenu_1whn0_120", Pa = "_icon_1whn0_130", Ma = "_arrow_1whn0_136", q = {
  link: Ca,
  active: ja,
  image: Ta,
  login: Na,
  label: La,
  trigger: za,
  caret: Sa,
  loginLink: Aa,
  dropdownMenu: Ia,
  icon: Pa,
  arrow: Ma
};
function Rt(e, t = !1) {
  if (typeof e == "string") return !1;
  const n = e.active === "active";
  if (!t || !e.href) return n;
  let r = e.href;
  try {
    r = new URL(e.href).pathname;
  } catch {
  }
  return r === window.location.pathname || n;
}
function Oa(e) {
  const [t, n] = S(Rt(e, !1));
  return C(() => {
    n(Rt(e, !0));
  }, [e]), t;
}
function Ea({
  link: e,
  Link: t,
  shouldSetActiveClass: n = !1,
  MenuItemComponent: r
}) {
  const o = Oa(e);
  return e === "separator" ? /* @__PURE__ */ c.jsx(Pr, {}) : /* @__PURE__ */ c.jsx(r, { children: /* @__PURE__ */ c.jsx(
    t,
    {
      "data-axe-expect": "color-contrast",
      className: k(q.link, { [q.active]: n && o }),
      href: e.href,
      children: e.name
    }
  ) });
}
function mc({
  text: { avatar: e = ka, name: t, links: n, myProfile: r },
  Link: o = Q,
  Image: a = Ke
}) {
  return /* @__PURE__ */ c.jsx(
    on,
    {
      wrapperClassName: q.dropdownMenu,
      Anchor: ct,
      marginInPx: 5,
      anchorClassName: q.arrow,
      alignContent: re.RIGHT,
      trigger: /* @__PURE__ */ c.jsxs(
        "button",
        {
          "data-axe-expect": "aria-valid-attr-value",
          className: k(q.trigger, q.login, Pe.navigationLink),
          id: "header-login-dropdown-toggle",
          children: [
            /* @__PURE__ */ c.jsx(a, { className: q.image, height: 36, width: 36, src: e, alt: `${t} - Avatar` }),
            /* @__PURE__ */ c.jsx("span", { className: q.label, children: r }),
            /* @__PURE__ */ c.jsx(oe, { name: "chevronDown", size: "400", color: "fg-content-primary", className: q.caret })
          ]
        }
      ),
      children: /* @__PURE__ */ c.jsx(Ar, { children: n.map((i, s) => /* @__PURE__ */ c.jsx(Ea, { link: i, Link: o, MenuItemComponent: Ir }, s)) })
    }
  );
}
function hc({ text: e, Link: t = Q }) {
  return /* @__PURE__ */ c.jsx("div", { className: q.login, children: /* @__PURE__ */ c.jsxs(
    t,
    {
      href: e.loginUrl,
      className: k(Pe.navigationLink, q.trigger, q.loginLink),
      title: e.label,
      "aria-label": e.label,
      children: [
        /* @__PURE__ */ c.jsx(oe, { name: "user", color: "fg-content-primary", className: q.icon, size: "400" }),
        /* @__PURE__ */ c.jsx("span", { className: q.label, children: e.label })
      ]
    }
  ) });
}
function bc() {
  return /* @__PURE__ */ c.jsxs("div", { className: k(q.trigger, q.login, Pe.navigationLink), children: [
    /* @__PURE__ */ c.jsx(Ne, { className: q.image, width: "40px", height: "40px", borderRadius: "100%" }),
    /* @__PURE__ */ c.jsx(Ne, { className: q.label, height: "28px", width: "164px" })
  ] });
}
export {
  xc as Alert,
  re as Alignment,
  Ra as AllowedInputTypes,
  En as AmountField,
  qa as AnimateList,
  Ka as AnimateNumber,
  wc as Badge,
  qn as Button,
  ot as Card,
  Ua as Checkbox,
  Va as ColorInput,
  Wa as Confetti,
  Xa as CopyText,
  ue as CopyTextState,
  Ja as DonationListItem,
  on as Dropdown,
  Ga as DropdownLabel,
  Ar as DropdownMenu,
  Ir as DropdownMenuItem,
  Pr as DropdownMenuSeparator,
  Ya as DropdownTrigger,
  vc as Fieldset,
  fc as Footer,
  uc as FooterCompact,
  ca as FooterDesktopSectionContent,
  aa as FooterMobileSectionContent,
  pc as Header,
  L0 as HeaderCompact,
  kn as Heading,
  oe as Icon,
  Re as IconButton,
  _c as JSONPrettyPrint,
  $o as LayoutAccordion,
  Do as LayoutAccordionItem,
  Tn as LayoutCenter,
  Te as LayoutCluster,
  kc as LayoutGrid,
  Qa as LayoutModal,
  Z as LayoutStack,
  Ne as LoadingSkeleton,
  dc as LocaleSwitchLink,
  lt as POPUP_CONTAINER_ATTR,
  et as POPUP_TRIGGER_ATTR,
  nn as Popup,
  en as PopupContext,
  G as Position,
  ec as ProgressBar,
  tc as RadioButton,
  Cc as RangeInput,
  Za as Select,
  Ft as TextInput,
  Ht as TextInputWrapper,
  qt as TextLink,
  nc as Textarea,
  jc as Tile,
  rc as ToggleButton,
  oc as ToggleSwitch,
  ac as Tooltip,
  cc as TooltipTrigger,
  mc as UserInfo,
  bc as UserInfoLoading,
  hc as UserLoginLink,
  ic as VirtualScroll,
  sc as VirtualScrollSSRFriendly,
  lc as WaveyWrapper,
  zt as findElementPopupParent,
  He as findFirstFocusableChild,
  it as findFirstFocusableChildOrRoot,
  Wt as findFocusableChildren,
  Qt as findNextFocusableElementExcludingChildren,
  Zt as findNextFocusableSibling,
  wr as findPreviousFocusableSibling,
  yr as getAriaDescribedBy,
  xr as getAriaRole,
  Se as getScrollParent,
  _r as isElementTriggerWithinTarget,
  vr as tick,
  Eo as useAccordionContext,
  Fa as useAttributeObserver,
  Ha as useDebouncedValue,
  at as useForwardedRef,
  Mn as useMutationObserver,
  Ae as usePopupContext,
  On as useResizeObserver
};
